export const langList: any = {
  menuList: {
    智能设备大屏: 'Smart screen for equipment',
    智能大屏: 'Smart screen',
    设备诊断: 'Equipment diagnosis',
    设备管理: 'Equipment management',
    报告管理: 'Report management',
    系统管理: 'System management',
    智能诊断: 'Intelligent diagnosis',
    诊断趋势: 'Diagnostic trends',
    标准监测: 'Standard monitoring',
    图谱分析: 'Spectrum analysis',
    分析工具: 'Analyzing tool',
    设备事件: 'Equipment event',
    设备档案: 'Equipment profile',
    数据下载: 'Data download',
    工况数据: 'Operating data',
    诊断报告: 'Diagnose report',
    个人报告: 'Personal report',
    检修报告: 'Maintenance report',
    周报月报: 'Weekly/Monthly report',
    账户管理: 'Account management',
    巡检管理: 'Inspection management',

    报警管理: 'Alarm management',
    状态监测报警: 'Status monitoring alarm',
    智能诊断报警: 'Intelligent diagnosis alarm',
    智能诊断模型配置: 'Smart diagnosis model configuration',
    工厂设备管理: 'Factory equipment management',
    测点管理: 'Measuring point management',
    系统配置: 'System configuration',
    系统日志: 'System log',
    日志管理: 'Log management',
    访问日志: 'Access log',
    工况触发采集配置: 'Condition trigger collection configuration',
    工况数据管理: 'Operating condition data management',
    工况采集卡管理: 'Operating condition capture card management',
    有线采集卡管理: 'Wired capture card management',
    诊断管理: 'Diagnostic management',
    模型配置: 'Model configuration',
    诊断工单管理: 'Diagnostic worksheet management',
    稳定状态清空: 'Steady-state clearing',
    数据清洗配置: 'Data cleaning configuration',
  },
  Chinese: {
    '语言':'语言',
    '主题':'主题',
    '蓝色':'蓝色',
    '白色':'白色',
    "中文": "中文",
    "英文": "英文",
    "关于": "关于",
    '合并报告': '合并报告',
    '巡检分数趋势': '巡检分数趋势',
    '智能诊断报告': '智能诊断报告',
    '基础巡检报告': '基础巡检报告',
    '全部测点': '全部测点',
    '巡检诊断': '巡检诊断',

    '基础指标': '基础指标',


    '最新巡检状态': '最新巡检状态',
    '最新巡检日期': '最新巡检日期',
    '巡检报告数量': '巡检报告数量',
    '巡检状态统计': '巡检状态统计',
    '巡检设备趋势': '巡检设备趋势',

    '本周巡检设备数': '本周巡检设备数',
    '本周巡检设备健康总览': '本周巡检设备健康总览',
    '幅值图': '幅值图',
    '巡检设备统计': '巡检设备统计',
    '设备运行正常': '设备运行正常',
    '全部区域': '全部区域',
    '巡检管理': '巡检管理',
    '巡检统计': '巡检统计',
    '巡检报告': '巡检报告',
    '巡检周报': '巡检周报',
    '巡检状态': '巡检状态',
    '巡检日期': '巡检日期',
    '日期': '日期',
    '巡检人': '巡检人',
    '巡检报告类型': '巡检报告类型',
    '导出': '导出',
    '请输入设备名称/编号/位号': '请输入设备名称/编号/位号',
    '基础': '基础',
    '智能': '智能',


    '精度': '精度',
    '选中': '选中',
    '公式': '公式',
    '公式名称': '公式名称',
    '公式内容': '公式内容',
    '数据值': '数据值',
    '变量': '变量',
    '公式模板': '公式模板',
    '测点配置': '测点配置',
    '使用公式': '使用公式',
    '未使用公式的设备': '未使用公式的设备',
    '已使用公式的设备': '已使用公式的设备',
    '数据转换公式': '数据转换公式',

    '列表显示': '列表显示',
    '台账显示': '台账显示',
    '波形': '波形',
    '压力': '压力',
    '工厂图': '工厂图',
    '编辑工厂': '编辑工厂',
    '新建工厂': '新建工厂',
    '更换工厂图': '更换工厂图',
    '左键添加标记': '左键添加标记',
    '左键按住可拖动': '左键按住可拖动',
    '右键添加标记': '右键添加标记',
    '上级工厂': 'Parent factory',
    '请填写区域名称': '请填写区域名称',
    '集团不能为自身工厂': '集团不能为自身工厂',
    '请填写工厂名称': '请填写工厂名称',
    '累计运行': '累计运行',
    '台': '台',
    '设备总数': '设备总数',
    '运行数': '运行数',
    '未关注': '未关注',
    '关注': '关注',
    '设备清单': '设备清单',
    '动轴承润滑不良': '动轴承润滑不良',
    '设备生命周期管理': '设备生命周期管理',
    'AI设备卫士': 'AI设备卫士',
    '智能大屏': '智能大屏',
    '设备诊断4.0': '设备诊断4.0',
    '设备管理4.0': '设备管理4.0',
    '报警管理4.0': '报警管理4.0',
    '报告管理4.0': '报告管理4.0',
    '系统配置': '系统配置',
    '诊断配置': '诊断配置',
    '知识库': '知识库',
    '集团大屏': '集团大屏',
    '厂级大屏': '厂级大屏',
    '设备大屏': '设备大屏',
    '设备健康总览': '设备健康总览',
    '诊断分析': '诊断分析',
    '设备列表': '设备列表',
    '报警列表': '报警列表',
    '推送规则': '推送规则',
    '专家看护配置': '专家看护配置',
    '报告管理': '报告管理',
    '角色管理': '角色管理',
    '账号管理': '账号管理',
    '菜单管理': '菜单管理',
    '工厂配置': '工厂配置',
    '监测范围': '监测范围',
    '监控设备数': '监控设备数',
    '监控测点数': '监控测点数',
    '运行设备数(运行率)': '运行设备数(运行率)',
    '全厂运行情况': '全厂运行情况',
    '系统持续服务运行 ': '系统持续服务运行 ',
    '全厂运行设备健康分数': '全厂运行设备健康分数 ',
    '设备健康状态统计': '设备健康状态统计',
    '健康': '健康',
    '可用': '可用',
    '警戒': '警戒',
    '故障': '故障',
    '设备运行状态统计': '设备运行状态统计',
    '运行': '运行',
    '停机': '停机',
    '待机': '待机',
    '设备报警数量统计': '设备报警数量统计',
    '可用报警': '可用报警',
    '警戒报警': '警戒报警',
    '故障报警': '故障报警',
    '未处理': '未处理',
    '已关闭': '已关闭',
    '已检修': '已检修',
    '本年': '本年',
    '本月': '本月',
    '本季度': '本季度',
    '本周': '本周',
    '各厂报警数量排行': '各厂报警数量排行',
    '显示该系统为工厂上线运行的时间': '显示该系统为工厂上线运行的时间',
    '监控设备数：用户所选组织下的监测设备数统计': '监控设备数：用户所选组织下的监测设备数统计',
    '监控测点数：用户所选组织下的监测测点数统计': '监控测点数：用户所选组织下的监测测点数统计',
    '运行设备数：用户所选组织下的监测设备中运行设备数统计': '运行设备数：用户所选组织下的监测设备中运行设备数统计',
    '运行率：用户所选组织下的监测设备中运行设备数/监测设备总数': '运行率：用户所选组织下的监测设备中运行设备数/监测设备总数',
    '设备报警趋势': '设备报警趋势',
    '设备报警记录': '设备报警记录',
    '报警时间': '报警时间',
    '区域清单': '区域清单',
    '显示单位': '显示单位',
    '监测设备': '监测设备',
    '监测测点': '监测测点',
    '运行设备': '运行设备',
    '报警设备': '报警设备',
    '未处理报警': '未处理报警',
    '运行率': '运行率',
    '请确认区域（车间）名称':'请确认区域（车间）名称',
    '所属行业':'所属行业',
    '请选择所属行业':'请选择所属行业',
    '工厂地址':'工厂地址',
    '请输入工厂地址':'请输入工厂地址',
    '请输入工厂名称':'请输入工厂名称',
    '地图标记':'地图标记',
    '当前运行状态': '当前运行状态',
    '设备厂家': '设备厂家',
    '设备状态占比': '设备状态占比',
    '运行占比': '运行占比',
    '运行时间': '运行时间',
    '健康占比': '健康占比',
    '健康时间': '健康时间',
    '可用占比': '可用占比',
    '可用时间': '可用时间',
    '警戒占比': '警戒占比',
    '警戒时间': '警戒时间',
    '故障占比': '故障占比',
    '故障时间': '故障时间',
    '累计运行时间': '累计运行时间',
    '分数趋势': '分数趋势',
    '报警事件': '报警事件',
    '检修记录': '检修记录',
    '诊断报醒': '诊断报醒',
    '已处理': '已处理',
    '请选择设备区域': '请选择设备区域',
    '请选择报警类型': '请选择报警类型',
    '请选择严重程度': '请选择严重程度',
    '关闭报警': '关闭报警',
    '下载报警': '下载报警',
    '请选择报警': '请选择报警',
    '请选择未处理的报警': '请选择未处理的报警',
    '请填写关闭原因': '请填写关闭原因',
    '关闭成功': '关闭成功',
    '请耐心等待，完成加载后，点击下载即可下载文件，请勿反复点击下载或关闭本网站': '请耐心等待，完成加载后，点击下载即可下载文件，请勿反复点击下载或关闭本网站',
    '请输入设备名称搜索': '请输入设备名称搜索',
    '请输入测点名称搜索': '请输入测点名称搜索',
    '设备健康状态': '设备健康状态',
    '综合状态': '综合状态',
    '设备基本信息': '设备基本信息',
    '设备位置': '设备位置',
    '收起': '收起',
    '展开': '展开',
    '近两月': '近两月',
    '设备健康事件时间轴': '设备健康事件时间轴',
    '健康指标诊断分数趋势图': '健康指标诊断分数趋势图',
    '振动指标诊断分数趋势图': '振动指标诊断分数趋势图',
    '是否显示': '是否显示',
    '显示': '显示',
    '隐藏': '隐藏',
    '开关机线': '开关机线',
    '运行时间趋势': '运行时间趋势',
    '指标监测趋势': '指标监测趋势',
    '指标值': '指标值',
    '检修事件': '检修事件',
    '添加检修记录': '添加检修记录',
    '批量关闭报警': '批量关闭报警',
    '排序': '排序',
    '事件类型': '事件类型',
    '诊断报警': '诊断报警',
    '请选择健康状态': '请选择健康状态',
    '运行状态': '运行状态',
    '请选择运行状态': '请选择运行状态',
    '请输入设备名称/编号': '请输入设备名称/编号',
    '新建设备': '新建设备',
    '测点列表': '测点列表',
    '设备序号': '设备序号',
    '是否实验台': '是否实验台',
    '请选择是否为试验台': '请选择是否为试验台',
    '所属工厂': '所属工厂',
    '报警记录': '报警记录',
    '健康总览': '健康总览',
    '测点位置': '测点位置',
    '请输入测点位置': '请输入测点位置',
    '新建测点': '新建测点',
    '编辑设备': '编辑设备',
    '设备照片': '设备照片',
    '故障信息': '故障信息',
    '故障详情': '故障详情',
    '检修照片': '检修照片',
    '诊断设备': '诊断设备',
    '建议及措施': '建议及措施',

    '编辑测点': '编辑测点',
    '请输入传感器SN': '请输入传感器SN',
    '请输入数采器编码': '请输入数采器编码',
    '请输入安装位置': '请输入安装位置',
    '转频提取': '转频提取',
    '请选择转频提取测点': '请选择转频提取测点',
    '请选择设备类型': '请选择设备类型',
    '请选择功率': '请选择功率',
    '请输入编号': '请输入编号',
    '请输入安装坐标': '请输入安装坐标',
    '请输入轴名称': '请输入轴名称',
    '测点照片': '测点照片',
    '请输入备注': '请输入备注',
    '编号': '编号',
    '水平径向': '水平径向',
    '竖直径向': '竖直径向',
    '传感器编号': '传感器编号',
    '轴名称': '轴名称',
    '测点ID': '测点ID',
    '是否试验台': '是否试验台',

    '总貌图': '总貌图',
    '左键按住可拖动，右键添加标记': '左键按住可拖动，右键添加标记',
    '关闭原因': '关闭原因',
    '旋转': '旋转',
    '更换3D图': '更换3D图',
    '更换2D图': '更换2D图',
    '选择设备区域': '选择设备区域',
    '选择严重程度': '选择严重程度',
    '请输入关键词搜索': '请输入关键词搜索',
    '检修详情': '检修详情',
    '开始时间': '开始时间',
    '结束时间': '结束时间',
    '检修人员': '检修人员',
    '现场设备状态': '现场设备状态',
    '故障描述': '故障描述',
    '健康设备': '健康设备',
    '可用设备': '可用设备',
    '警戒设备': '警戒设备',
    '故障设备': '故障设备',
    '分析周期': '分析周期',

    '故障模式统计(本年)': '故障模式统计(本年)',
    '本周检修/检查': '本周检修/检查',
    '本月检修/检查': '本月检修/检查',
    '周报转发：复制链接转发，用户可在电脑端或手机端查看': '周报转发：复制链接转发，用户可在电脑端或手机端查看',
    '手机端链接': '手机端链接',
    '参数配置': '参数配置',
    '操作日志': '操作日志',
    '登录日志': '登录日志',
    '数据变更日志': '数据变更日志',
    '数采器列表': '数采器列表',
    '传感器监测': '传感器监测',
    '服务监测': '服务监测',
    '系统监测报警': '系统监测报警',
    '工况对接配置': '工况对接配置',
    '周报配置': '周报配置',

    '智能诊断报警配置': '智能诊断报警配置',
    '标准监测报警配置': '标准监测报警配置',
    '非标设备管理': '非标设备管理',
    '设备首页': '设备首页',

    '三级菜单测试第二级': '三级菜单测试第二级',
    '三级菜单测试第三级': '三级菜单测试第三级',
    '设备事件报警': '设备事件报警',


    '测试三级2': '测试三级2',
    '故障标准库': '故障标准库',
    '3D模型库': '3D模型库',
    '开关机配置': '开关机配置',
    '采集器列表': '采集器列表',


    '请输入角色名称': '请输入角色名称',
    '请选择菜单': '请选择菜单',
    '请选择工厂权限': '请选择工厂权限',
    '工厂权限': '工厂权限',
    '确定删除此条数据么': '确定删除此条数据么',


    '昵称/用户名/手机号': '昵称/用户名/手机号',
    '请选择所属工厂': '请选择所属工厂',
    '配置': '配置',
    '配置权限': '配置权限',
    '输入用户名': '输入用户名',
    '输入昵称': '输入昵称',
    '不修改密码无需输入': '不修改密码无需输入',

    '菜单名称': '菜单名称',
    '菜单路由': '菜单路由',
    '菜单Code': '菜单Code',
    '上级菜单': '上级菜单',
    '菜单类型': '菜单类型',
    '按钮': '按钮',
    '链接': '链接',
    '路由地址': '路由地址',
    '请输入路由地址': '请输入路由地址',
    '菜单排序': '菜单排序',
    '菜单状态': '菜单状态',
    '一级菜单': '一级菜单',
    '定位': '定位',
    '集团': '集团',
    '请选择集团': '请选择集团',

    '故障释义': '故障释义',
    '一级分类': '一级分类',
    '请输入一级分类': '请输入一级分类',
    '二级分类': '二级分类',
    '请输入二级分类': '请输入二级分类',
    '三级分类': '三级分类',
    '请输入三级分类': '请输入三级分类',
    '缩写': '缩写',
    '请输入缩写': '请输入缩写',
    '模型图': '模型图',

    '输入区域或设备名称筛选': '输入区域或设备名称筛选',
    '未选择设备或没有配置测点': '未选择设备或没有配置测点',
    '粘贴': '粘贴',

    '确定删除所选数据么': '确定删除所选数据么',
    '请选择复制的内容': '请选择复制的内容',
    '不允许粘贴': '不允许粘贴',
    '没有复制的内容': '没有复制的内容',
    '请选择内容': '请选择内容',
    '振动参数': '振动参数',


    '请选择项目': '请选择项目',
    '诊断工单(待完成)': '诊断工单(待完成)',
    '诊断工单(已完成)': '诊断工单(已完成)',
    '确认删除': '确认删除',
    '请填写诊断判断备注': '请填写诊断判断备注',
    '保存任务处理': '保存任务处理',

    '请输入切片数': '请输入切片数',
    '请选择工厂后提交': '请选择工厂后提交',
    '周报月报配置': '周报月报配置',
    '报告生成策略': '报告生成策略',
    '是否生成报告': '是否生成报告',
    '每月第': '每月第',
    '每周第': '每周第',
    '天生成月报': '天生成月报',
    '天生成周报': '天生成周报',
    '星期一': '星期一',
    '星期二': '星期二',
    '星期三': '星期三',
    '星期四': '星期四',
    '星期五': '星期五',
    '星期六': '星期六',
    '星期日': '星期日',
    '第': '第',
    '小时生成报告': '小时生成报告',


    '故障信息(请勾选此次维修的故障项)': '故障信息(请勾选此次维修的故障项)',
    '维修详情': '维修详情',
    '故障信息(请勾选此次关闭的故障项)': '故障信息(请勾选此次关闭的故障项)',
    '检修图片': '检修图片',
    '请选择开始时间': '请选择开始时间',
    '请选择结束时间': '请选择结束时间',
    '请填写检修人员': '请填写检修人员',
    '请选择现场设备状态': '请选择现场设备状态',
    '请填写故障原因': '请填写故障原因',
    '请填写检修内容': '请填写检修内容',
    '新增成功': '新增成功',
    '请选择关闭的故障项': '请选择关闭的故障项',
    '低频加速度X(m/s2)': '低频加速度X(m/s2)',
    '低频加速度Y(m/s2)': '低频加速度Y(m/s2)',
    '低频加速度Z(m/s2)': '低频加速度Z(m/s2)',
    '温度(­°C)': '温度(­°C)',
    '速度X(mm/s)': '速度X(mm/s)',
    '速度Y(mm/s)': '速度Y(mm/s)',
    '速度Z(mm/s)': '速度Z(mm/s)',
    '高频加速度(m/s2)': '高频加速度(m/s2)',

    '低频加速度X': '低频加速度X',
    '低频加速度Y': '低频加速度Y',
    '低频加速度Z': '低频加速度Z',
    '速度X': '速度X',
    '速度Z': '速度Z',

    '健康设备数': '健康设备数',
    '可用设备数': '可用设备数',
    '警戒设备数': '警戒设备数',
    '故障设备数': '故障设备数',
    '停机设备数': '停机设备数',
    '待机设备数': '待机设备数',
    '运行设备数': '运行设备数',

    '高频加速度(长)': '高频加速度(长)',
    '速度Y': '速度Y',
    '趋势图': '趋势图',
    '时域图': '时域图',
    '现场情况': '现场情况',
    '有效值': '有效值',
    '倍频': '倍频',
    '边频': '边频',
    '清空标注': '清空标注',
    '值': '值',
    '暂无下载文件': '暂无下载文件',

    '频谱': '频谱',
    '选择范围': '选择范围',
    '包络解调': '包络解调',
    '采样时间': '采样时间',
    '振动指标-均方根': '振动指标-均方根',
    '振动指标-0~0.3KHz均方根': '振动指标-0~0.3KHz均方根',
    '振动指标-0~1KHz均方根': '振动指标-0~1KHz均方根',
    '振动指标-1K~10KHz均方根': '振动指标-1K~10KHz均方根',
    '振动指标-10K~25.6KHz均方根': '振动指标-10K~25.6KHz均方根',
    '振动指标-1K~25.6KHz均方根': '振动指标-1K~25.6KHz均方根',
    '振动指标-0~25.6KHz均方根': '振动指标-0~25.6KHz均方根',
    '振动指标-优化峭度01': '振动指标-优化峭度01',
    '振动指标-平稳冲击烈度': '振动指标-平稳冲击烈度',
    '振动指标-线性峭度02': '振动指标-线性峭度02',
    '振动指标-峭度因子': '振动指标-峭度因子',
    '振动指标-峰峰值': '振动指标-峰峰值',
    '振动指标-优化峰值': '振动指标-优化峰值',
    '振动指标-优化偏度': '振动指标-优化偏度',
    '振动指标-速度均方根': '振动指标-速度均方根',
    '振动指标-频率集中度': '振动指标-频率集中度',
    '振动指标-0.3~1KHz均方根': '振动指标-0.3~1KHz均方根',
    '振动指标-1K~3KHz均方根': '振动指标-1K~3KHz均方根',
    '振动指标-3K~6KHz均方根': '振动指标-3K~6KHz均方根',
    '振动指标-6K~12KHz均方根': '振动指标-6K~12KHz均方根',
    '振动指标-12000~25600Hz均方根': '振动指标-12000~25600Hz均方根',
    '振动指标-6K~10KHz均方根': '振动指标-6K~10KHz均方根',
    '振动指标-优化均方根': '振动指标-优化均方根',
    '振动指标-偏度因子': '振动指标-偏度因子',
    '振动指标-裕度因子': '振动指标-裕度因子',
    '振动指标-峰值指标': '振动指标-峰值指标',
    '振动指标-包络信息熵': '振动指标-包络信息熵',
    '振动指标-包络幅值峭度': '振动指标-包络幅值峭度',
    '振动指标-脉冲因子': '振动指标-脉冲因子',
    '振动指标-波形因子': '振动指标-波形因子',
    '振动指标-均值频率': '振动指标-均值频率',
    '振动指标-主频带位置': '振动指标-主频带位置',
    '振动指标-时域信息熵': '振动指标-时域信息熵',
    '振动指标-频域信息熵': '振动指标-频域信息熵',
    '振动指标-电流指标': '振动指标-电流指标',
    '趋势波形图': '趋势波形图',
    '多时域频谱': '多时域频谱',
    '诊断分数趋势': '诊断分数趋势',
    '倒频谱': '倒频谱',
    '加速度均方根': '加速度均方根',

    '幅值-m/s²': '幅值-m/s²',
    '频率-Hz': '频率-Hz',
    '振动指标-Trms': '振动指标-Trms',
    '振动指标-Trms_300': '振动指标-Trms_300',
    '振动指标-Trms_1000': '振动指标-Trms_1000',
    '振动指标-Trms_1000_10000': '振动指标-Trms_1000_10000',
    '振动指标-Trms_10000_25600': '振动指标-Trms_10000_25600',
    '振动指标-Trms_1000_25600': '振动指标-Trms_1000_25600',
    '振动指标-TLinKurt': '振动指标-TLinKurt',
    '振动指标-TImpactIntensity': '振动指标-TImpactIntensity',
    '振动指标-Tlin_kurt': '振动指标-Tlin_kurt',
    '振动指标-Tkurt': '振动指标-Tkurt',
    '振动指标-Tff': '振动指标-Tff',
    '振动指标-TAccelerationPeak': '振动指标-TAccelerationPeak',
    '振动指标-Tlin_bias': '振动指标-Tlin_bias',
    '振动指标-TVelocityRMS': '振动指标-TVelocityRMS',
    '振动指标-Tcon': '振动指标-Tcon',
    '振动指标-Trms_300_1000': '振动指标-Trms_300_1000',
    '振动指标-Trms_1000_3000': '振动指标-Trms_1000_3000',
    '振动指标-Trms_3000_6000': '振动指标-Trms_3000_6000',
    '振动指标-Trms_6000_12000': '振动指标-Trms_6000_12000',
    '振动指标-Trms_12000_25600': '振动指标-Trms_12000_25600',
    '振动指标-Trms_6000_10000': '振动指标-Trms_6000_10000',
    '振动指标-TAccelerationRMS': '振动指标-TAccelerationRMS',
    '振动指标-Tbias': '振动指标-Tbias',
    '振动指标-Tmargin': '振动指标-Tmargin',
    '振动指标-Tpp': '振动指标-Tpp',
    '振动指标-Tent_e': '振动指标-Tent_e',
    '振动指标-Tenv_kurt': '振动指标-Tenv_kurt',
    '振动指标-Tpulse': '振动指标-Tpulse',
    '振动指标-Twave': '振动指标-Twave',
    '振动指标-TF9': '振动指标-TF9',
    '振动指标-Tmainf': '振动指标-Tmainf',
    '振动指标-Tent_t': '振动指标-Tent_t',
    '振动指标-Tent_f': '振动指标-Tent_f',
    '振动指标-Tcurrent': '振动指标-振动指标-Tcurrent',
    电机驱动端: '电机驱动端',
    一轴输入端: '一轴输入端',
    一轴输出端: '一轴输出端',
    二轴输入端: '二轴输入端',
    二轴输出端: '二轴输出端',
    三轴输出端: '三轴输出端',
    滚筒轴承: '滚筒轴承',

    左侧滚筒轴承: '左侧滚筒轴承',
    左侧电机驱动端: '左侧电机驱动端',
    三轴输入端: '三轴输入端',
    四轴左侧输出端: '四轴左侧输出端',
    四轴右侧输出端: '四轴右侧输出端',
    右侧滚筒轴承: '右侧滚筒轴承',
    一轴左侧输入端: '一轴左侧输入端',
    一轴右侧输入端: '一轴右侧输入端',
    右侧电机驱动端: '右侧电机驱动端',


    四轴输出端: '四轴输出端',


    查看详情: '查看详情',
    返回机房: '返回机房',
    暂无事件: '暂无事件',
    条: '条',
    查看更多: '查看更多',
    点击查看详情: '点击查看详情',
    机房: '机房',
    健康指标: '健康指标',
    振动指标: '振动指标',
    分: '分',
    系统持续服务运行: "系统持续服务运行",
    区域健康评分: '区域健康评分',
    '针对运行中的设备, 状态得分的加权平均数计算为全厂健康分数, 健康设备记100分, 可用设备记80分, 警戒设备记60分, 故障设备记30分': '针对全部设备, 状态得分的加权平均数计算为全厂健康分数, 健康设备记100分, 可用设备记80分, 警戒设备记60分, 故障设备记30分',
    传感器安装位置: '传感器安装位置',
    转速: '转速',
    时间: '时间',
    操作: '操作',
    下载: '下载',
    条数据: '条数据',
    请耐心等待完成加载后点击确认即可下载文件请勿反复点击下载或关闭本网站: '请耐心等待，完成加载后，点击确认即可下载文件，请勿反复点击下载或关闭本网站。',
    共: '共',
    近一天: '近一天',
    近一周: '近一周',
    近一月: '近一月',
    自定义: '自定义',
    筛选: '筛选',
    自动刷新: '自动刷新',
    关闭: '关闭',
    开启: '开启',
    工况数据: '工况数据',
    工况名称: '工况名称',
    工况值: '工况值',
    工况信息图表: '工况信息图表',
    全部设备: '全部设备',
    搜索: '搜索',
    搜索设备信息: '搜索设备信息',
    设备名称: '设备名称',
    设备区域: '设备区域',
    安装位置: '安装位置',
    当前状态: '当前状态',
    健康状态描述: '健康状态描述',
    状态: '状态',
    分数等级: '分数等级',
    建议客户的行为: '建议客户的行为',
    建议使用时间: '建议使用时间',


    可用上: '可用上',
    可用下: '可用下',
    警戒上: '警戒上',
    警戒中: '警戒中',
    警戒下: '警戒下',
    故障上: '故障上',
    故障下: '故障下',
    无: '无',
    无需操作: '无需操作',
    可持续使用: '可持续使用',
    一级可用: '一级可用',
    二级可用: '二级可用',
    一级警戒: '一级警戒',
    二级警戒: '二级警戒',
    发现异常特征关注AI设备卫士中设备分数变化趋势: '发现异常特征，关注AI设备卫士中设备分数变化趋势',
    发现异常特征按照巡查计划现场查看设备状态: '发现异常特征，按照巡查计划现场查看设备状态',
    天07内查看: '0-7天内查看',
    具体时间因设备和故障类型而异: '具体时间因设备和故障类型而异',
    发现明显异常特征现场检查设备状态根据现场检查结果更新维护计划: '发现明显异常特征，现场检查设备状态，根据现场检查结果更新维护计划',
    天03内检查天170内维护: '0-3天内检查，1-70天内维护',
    发现明显异常特征现场检查设备状态制定维护计划适时维护设备: '发现明显异常特征，现场检查设备状态，制定维护计划，适时维护设备',
    天03内检查天130内维护: '0-3天内检查，1-30天内维护',
    停止运行机器进行维护: '停止运行机器，进行维护',
    尽快停机: '尽快停机',
    健康状态: '健康状态',
    运行中: '运行中',
    已停止: '已停止',
    查看: '查看',
    诊断报告: '诊断报告',
    检修报告: '检修报告',
    设备详情: '设备详情',
    设备型号: '设备型号',
    设备品牌: '设备品牌',
    添加日期: '添加日期',
    设备描述: '设备描述',
    个人报告: '个人报告',
    周报月报: '周报月报',
    账户管理: '账户管理',

    报警管理: '报警管理',
    状态监测报警: '状态监测报警',
    智能诊断报警: '智能诊断报警',
    智能诊断模型配置: '智能诊断模型配置',
    工厂设备管理: '工厂设备管理',
    设备管理: '设备管理',
    测点管理: '测点管理',

    系统日志: '系统日志',
    日志管理: '日志管理',
    访问日志: '访问日志',
    工况触发采集配置: '工况触发采集配置',
    工况数据管理: '工况数据管理',
    工况采集卡管理: '工况采集卡管理',
    有线采集卡管理: '有线采集卡管理',
    诊断管理: '诊断管理',
    模型配置: '模型配置',
    诊断工单管理: '诊断工单管理',
    稳定状态清空: '稳定状态清空',
    数据清洗配置: '数据清洗配置',
    搜索设备信息报告内容等: '搜索设备信息、报告内容等',
    选择日期: '选择日期',
    设备: '设备',
    诊断描述: '诊断描述',
    严重程度: '严重程度',
    最近更新: '最近更新',
    轻微: '轻微',
    中度: '中度',
    严重: '严重',
    诊断详情: '诊断详情',
    健康事件: '健康事件',
    可用事件: '可用事件',
    警戒事件: '警戒事件',
    故障事件: '故障事件',
    幅值谱图: '幅值谱图',
    包络谱图: '包络谱图',
    故障原因: '故障原因',
    备注: '备注',
    报告状态: '报告状态',
    数据源: '数据源',
    提交日期: '提交日期',
    已诊断: '已诊断',
    诊断中: '诊断中',
    个人申请: '个人申请',
    巡检记录: '巡检记录',
    异常数据报警: '异常数据报警',
    个人报告信息: '个人报告信息',
    诊断中请耐心等待: '诊断中，请耐心等待',
    当前设备问题严重程度为重度请及时进行检查与维修: '当前设备问题严重程度为重度，请及时进行检查与维修',
    当前设备问题严重程度为中度请密切关注请结合现场情况适时检查: '当前设备问题严重程度为中度，请密切关注，请结合现场情况适时检查。',
    当前设备问题严重程度为轻度请关注: '当前设备问题严重程度为轻度，请关注。',
    诊断结论: '诊断结论',
    报告内容: '报告内容',
    现场照片: '现场照片',
    未上传: '未上传',
    设备信息: '设备信息',
    检修日期: '检修日期',
    检修内容: '检修内容',
    故障类型: '故障类型',
    检修人: '检修人',
    提交时间: '提交时间',
    检修报告详情: '检修报告详情',
    检修结果: '检修结果',
    综合健康状态: '综合健康状态',
    当前设备分数: '当前设备状态',
    现场设备状态判断: '现场设备状态判断',
    现场反馈详情: '现场反馈详情',
    故障模式: '故障模式',
    一致性: '一致性',
    一致: '一致',
    不确定: '不确定',
    不一致: '不一致',
    操作记录: '操作记录',
    检修信息: '检修信息',
    报告标题: '报告标题',
    报告周期: '报告周期',
    报告类型: '报告类型',
    周: '周',
    月报: '月报',
    周报: '周报',
    报告统计时间: '报告统计时间',
    报告日期: '报告日期',
    设备详情清单: '设备详情清单',
    取消: '取消',
    保存: '保存',
    设备状态: '设备状态',
    状态变化: '状态变化',
    诊断结果: '诊断结果',
    未知因素: '未知因素',
    本周检修检查: '本周检修/检查',
    pc端链接: 'pc端链接',
    移动端链接: '移动端链接',
    周报转发分别复制链接转发用户可在电脑端或手机端查看: '周报转发：分别复制链接转发，用户可在电脑端或手机端查看',
    本周设备健康总览: '本周设备健康总览',
    本周设备事件提醒总览: '本周设备事件提醒总览',
    故障模式统计本年: '故障模式统计（本年）',
    有线采集管理: '有线采集管理',
    成功: '成功',
    失败: '失败',
    添加账户: '添加账户',
    昵称: '昵称',
    用户名: '用户名',
    角色: '角色',
    手机号: '手机号',
    是否启用: '是否启用',
    权限标签: '权限标签',
    关键词: '关键词',
    昵称用户名手机号: '昵称/用户名/手机号',
    全部: '全部',
    是: '是',
    否: '否',
    编辑: '编辑',
    停用: '停用',
    启用: '启用',
    重置密码: '重置密码',
    修改密码: '修改密码',
    修改账户: '修改账户',
    请输入用户名: '请输入用户名',
    请输入昵称: '请输入昵称',
    密码: '密码',
    验证码: 'Captcha',
    密码至少8位: '密码至少8位',
    随机生成: '随机生成',
    请选择角色: '请选择角色',
    工厂: '工厂',
    请输入手机号: '请输入手机号',
    请选择工厂: '请选择工厂',
    请选择: '请选择',
    确定: '确定',
    重置该用户密码: '重置该用户密码',
    新密码: '新密码',
    旧密码: '旧密码',
    角色名: '角色名',
    查询: '查询',
    菜单: '菜单',
    删除: '删除',
    新增: '新增',
    确认删除该角色: '确认删除该角色!',
    保存成功: '保存成功',
    保存失败: '保存失败',
    编辑成功: '编辑成功',
    操作成功: '操作成功',
    区域: '区域',
    设备id: '设备id',
    设备类型: '设备类型',
    厂家: '厂家',
    型号: '型号',
    机器SN号: '机器SN号',
    序号: '序号',
    是否是试验台: '是否是试验台',
    传感器位置: '传感器位置',
    设备类型缩写: '设备类型缩写',
    生产厂家: '生产厂家',
    设备SN号: '设备SN号',
    试验台: '试验台',
    版本: '版本',
    旗舰版: '旗舰版',
    商业版: '商业版',
    设备图片: '设备图片',
    上传: '上传',
    提交: '提交',
    请输入: '请输入',
    操作失败: '操作失败',
    文件上传失败请联系管理员: '文件上传失败,请联系管理员',
    传感器SN: '传感器SN',
    数采器编码: '数采器编码',
    是否有网关: '是否有网关',
    测点id: '测点id',
    当前设备: '当前设备',
    转频提取测点: '转频提取测点',
    轴参数: '轴参数',
    DT编号: 'DT编号',
    安装坐标: '安装坐标',
    名称: '名称',
    报警类型: '报警类型',
    高频: '高频',
    低频: '低频',
    路径: '路径',
    更新时间: '更新时间',
    当前值: '当前值',
    特性: '特性',
    所属设备: '所属设备',
    功率: '功率',
    三轴参数: '三轴参数',
    数据类型: '数据类型',
    默认展示数据类型: '默认展示数据类型',
    保存路径: '保存路径',
    上次更新: '上次更新',
    添加: '添加',
    生成三轴参数: '生成三轴参数',
    选择: '选择',
    搜索测点信息: '搜索测点信息',
    是否推送: '是否推送',
    推送人: '推送人',
    清空: '清空',
    说明: '说明',
    测点: '测点',
    指标名称: '指标名称',
    单位与描述: '单位与描述',
    一级门限可用: '一级门限可用',
    报警间隔天: '报警间隔天',
    二级门限警戒: '二级门限警戒',
    三级门限故障: '三级门限故障',
    不推送: '不推送',
    确认: '确认',
    同步标准: '同步标准',
    基于国际国家或行业内既定标准实现对设备运行状态进行监测同时可纵向参考设备历史运行数据横向比较同类设备运行数据确定各报警等级的阈值: '基于国际、国家或行业内既定标准，实现对设备运行状态进行监测。同时，可纵向参考设备历史运行数据，横向比较同类设备运行数据，确定各报警等级的阈值。',
    但依据标准设定的绝对合理的阈值很难获取设定过高的报警阈值会造成设备故障: '但依据标准设定的绝对合理的阈值很难获取，设定过高的报警阈值会造成设备故障',
    漏报: '漏报',
    的风险而阈值过低又会来带大量的: '的风险，而阈值过低又会来带大量的',
    误报警: '误报警',
    给现场处理造成极大的压力此外仅按照标准规定中的几种指标设定的阈值报警所能发现的故障模式有限设置和修改阈值也面临必需手动调整与工作量大等问题: '，给现场处理造成极大的压力；此外，仅按照标准规定中的几种指标设定的阈值报警所能发现的故障模式有限。设置和修改阈值也面临必需手动调整与工作量大等问题。',
    根据各类国际国家行业标准根据对目前所有设备类型参照相应标准做如下统计: '根据各类国际、国家、行业标准，根据对目前所有设备类型，参照相应标准，做如下统计：',
    采用标准: '采用标准',
    电机类: '电机类',
    泵类: '泵类',
    往复类: '往复类',
    风机类: '风机类',
    齿轮类: '齿轮类',
    螺杆式: '螺杆式',
    汽轮机: '汽轮机',
    通用设备: '通用设备',
    报警策略: '报警策略',
    工况异常处理: '工况异常处理',
    是否专家看护: '是否专家看护',
    是否专家认证: '是否专家认证',
    分指标报警: '分指标报警',
    按设备整体状态: '按设备整体状态',
    单点即刻报警: '单点即刻报警',
    短期重复出现报警: '短期重复出现报警',
    智能诊断报警策略组合: '智能诊断报警策略组合',
    一旦监测到分数异常即刻报警: '一旦监测到分数异常，即刻报警',
    统计短期内重复出现同类型异常报警去除工况突变数据采集等异常值误报: '统计短期内重复出现同类型异常报警，去除工况突变、数据采集等异常值误报',
    每个指标发生分数恶化都单独发送报警: '每个指标发生分数恶化，都单独发送报警',
    适合处于非健康状态或指标磨合期的设备需要故障模式报警: '适合处于非健康状态，或指标磨合期的设备，需要故障模式报警',
    适合运行较稳定需要故障模式报警: '适合运行较稳定，需要故障模式报警',
    仅当设备整体状态恶化时发送报警: '仅当设备整体状态恶化时，发送报警',
    用于对整体设备状态监测非健康设备报警时效性要求高: '用于对整体设备状态监测，非健康设备报警时效性要求高',
    用于对整体设备状态监测设备运行较稳定趋势性变化突发异常概率低: '用于对整体设备状态监测，设备运行较稳定，趋势性变化突发异常概率低',
    笔内出现: '笔内，出现',
    次: '次',
    开关机影响时间范围: '开关机影响时间范围',
    分钟: '分钟',
    范围: '范围',
    状态回升灵敏度: '状态回升灵敏度',
    距最近开机: '距最近开机',
    笔数据判断状态向前: '笔数据判断状态，向前',
    笔数据判断状态: '笔数据判断状态。',
    请选择工厂后再提交: '请选择工厂后再提交!',
    请选择区域后再提交: '请选择区域后再提交!',
    请选择设备后再提交: '请选择设备后再提交!',
    请选择报警策略后再提交: '请选择报警策略后再提交!',
    请填写工况异常处理后再提交: '请填写工况异常处理后再提交!',
    该区域中存在重复配置的设备: '该区域中存在重复配置的设备',
    首页大屏布局: '首页大屏布局',
    默认版式: '默认版式',
    设备列表版式: '设备列表版式',
    实验采集版式: '实验采集版式',
    操作用户: '操作用户',
    操作路由: '操作路由',
    操作数据: '操作数据',
    操作时间: '操作时间',
    设备编号: '设备编号',
    采集对象: '采集对象',
    工况类型或编号: '工况类型或编号',
    运算符: '运算符',
    门限值: '门限值',
    保持状态延时: '保持状态延时',
    误差率: '误差率',
    波形采集: '波形采集',
    监测指标采集: '监测指标采集',
    秒: '秒',
    确定要删除: '确定要删除？',
    请选择设备后进行操作: '请选择设备后进行操作',
    标签: '标签',
    类型: '类型',
    禁用: '禁用',
    振动加速度: '振动加速度',
    振动速度: '振动速度',
    温度: '温度',
    出口流量: '出口流量',
    频率: '频率',
    实际压力: '实际压力',
    出口压力: '出口压力',
    电流: '电流',
    电压:'电压',
    扭矩: '扭矩',
    未绑定: '未绑定',
    请选择设备: '请选择设备',
    请选择类型: '请选择类型',
    采集卡编码: '采集卡编码',
    采集卡ip: '采集卡ip',
    采集卡类型: '采集卡类型',
    工厂名称: '工厂名称',
    传感器通道: '传感器通道',
    通道: '通道',
    采集卡配置: '采集卡配置',
    基本信息: '基本信息',
    采集配置: '采集配置',
    采集间隔: '采集间隔',
    工况通道配置: '工况通道配置',
    工况通道号: '工况通道号',
    选择测点: '选择测点',
    请填写采集卡编码: '请填写采集卡编码',
    请选择采集卡类型: '请选择采集卡类型',
    请选择区域: '请选择区域',
    请填写安装位置: '请填写安装位置',
    请填写采集卡ip: '请填写采集卡ip',
    请完成工况通道配置的编辑后提交: '请完成工况通道配置的编辑后提交',
    请选择采集卡类型后操作: '请选择采集卡类型后操作！',
    采集卡id: '采集卡id',
    ip地址: 'ip地址',
    边缘电脑绑定: '边缘电脑绑定',
    波形采集配置: '波形采集配置',
    采集方式: '采集方式',
    波形间隔: '波形间隔',
    采样频率: '采样频率',
    采样时长: '采样时长',
    监测指标采集配置: '监测指标采集配置',
    均方根间隔: '均方根间隔',
    触发条件需要同时满足不填写触发条件系统即认为触发条件满足等同于定时采集: '触发条件需要同时满足。不填写触发条件，系统即认为触发条件满足，等同于定时采集',
    通道配置: '通道配置',
    通道号: '通道号',
    关联测点名称: '关联测点名称',
    灵敏度: '灵敏度',
    轴向: '轴向',
    轴向名称: '轴向名称',
    定时采集: '定时采集',
    满足触发条件的定时采集: '满足触发条件的定时采集',
    所选通道数量小于通道配置数量: '所选通道数量小于通道配置数量',
    请选择采集卡类型后再添加: '请选择采集卡类型后再添加',
    通道数量超过所选的: '通道数量超过所选的',
    请填写ip地址: '请填写ip地址',
    请选择波形采集配置的波形间隔: '请选择波形采集配置的波形间隔',
    请选择波形采集配置的采样频率: '请选择波形采集配置的采样频率',
    请选择波形采集配置的采样时长: '请选择波形采集配置的采样时长',
    请选择检测指标采集配置的波形间隔: '请选择检测指标采集配置的波形间隔',
    请选择检测指标采集配置的采样频率: '请选择检测指标采集配置的采样频率',
    请完成通道配置的编辑后提交: '请完成通道配置的编辑后提交',
    通道号过大: '通道号大于',
    请填写灵敏度后提交: '请填写灵敏度后提交',
    切片数: '切片数',
    滤波方式: '滤波方式',
    滤波频段: '滤波频段',
    请选择滤波方式: '请选择滤波方式',
    新增行: '新增行',
    选择设备: '选择设备',
    带通滤波: '带通滤波',
    带阻滤波: '带阻滤波',
    设备选择: '设备选择',
    操作日期范围: '操作日期范围',
    重置: '重置',
    项目: '项目',
    状态清空时间: '状态清空时间',
    负责人: '负责人',
    上一小时状态: '上一小时状态',
    是否改变状态: '是否改变状态',
    设备稳定状态清空: '设备稳定状态清空',
    指标: '指标',
    状态清零记录: '状态清零记录',
    状态回升记录: '状态回升记录',
    该设备在此时间点为关机状态请重新选择: '该设备在此时间点为关机状态，请重新选择',
    选择的时间点暂无稳定状态请重新选择: '选择的时间点暂无稳定状态,请重新选择',
    请选择测点后再选择指标: '请选择测点后再选择指标',
    请选择日期: '请选择日期',
    日期范围: '日期范围',
    设备参数配置: '设备参数配置',
    专业指标: '专业指标',
    通用指标: '通用指标',
    其他: '其他',
    其它: '其它',
    复制: '复制',
    粘贴覆盖: '粘贴覆盖',
    粘贴追加: '粘贴追加',
    恢复为该测点对应的阈值标准值: '恢复为该测点对应的阈值标准值',
    未配置标准则保留配置值: '未配置标准则保留配置值',
    细分故障: '细分故障',
    计算方法: '计算方法',
    全选: '全选',
    复制成功: '复制成功!',
    请先选择需要复制的内容: '请先选择需要复制的内容',
    粘贴成功: '粘贴成功',
    复制内容无法粘贴在该指标下: '复制内容无法粘贴在该指标下!',
    请先复制内容: '请先复制内容!',
    删除成功: '删除成功',
    请先选择需要删除的内容: '请先选择需要删除的内容',
    请保存后再切换: '请保存后再切换!',
    确认执行该操作: '确认执行该操作!',
    返回: '返回',
    部件参数: '部件参数',
    通用参数: '通用参数',
    部件参数新增: '部件参数新增',
    部件类型: '部件类型',
    配置参数: '配置参数',
    数量: '数量',
    参数释义: '参数释义',
    客户: '客户',
    诊断经理: '诊断经理',
    是否采纳: '是否采纳',
    反馈是否有故障: '反馈是否有故障',
    是否曾发送诊断事件: '是否曾发送诊断事件',
    是否更改稳定状态: '是否更改稳定状态',
    诊断处理: '诊断处理',
    发生时间: '发生时间',
    客户经理: '客户经理',
    稳定状态: '稳定状态',
    上一小时稳定状态: '上一小时稳定状态',
    事件状态: '事件状态',
    是否前台显示: '是否前台显示',
    故障模式一致性: '故障模式一致性',
    诊断确认: '诊断确认',
    调整阈值: '调整阈值',
    专家报告: '专家报告',
    状态清零: '状态清零',
    诊断事件: '诊断事件',
    待完成: '待完成',
    已完成: '已完成',
    客户反馈: '客户反馈',
    确认提交: '确认提交',
    导出详情: '导出详情',
    我的未完成项: '我的未完成项',
    取消选择: '取消选择',
    内部事件类型: '内部事件类型',
    警戒及以下: '警戒及以下',
    诊断待处理: '诊断待处理',
    客户支持待处理: '客户支持待处理',
    完成: '完成',
    诊断判断内部备注: '诊断判断内部备注',
    诊断判断备注: '诊断判断备注',
    专家报告id: '专家报告id',
    添加专家报告: '添加专家报告',
    请确认是否清空当前设备稳定状态: '请确认是否清空当前设备稳定状态',
    客户支持: '客户支持',
    事件进展: '事件进展',
    反馈一致性: '反馈一致性',


    自动诊断: '自动诊断',
    人工诊断: '人工诊断',
    客户支持备注: '客户支持备注',
    附件: '附件',
    否无效反馈: '否,无效反馈',
    否模糊: '否,模糊',
    状态反馈一致性: '状态反馈一致性',
    认同: '认同',
    不认同: '不认同',
    修改后认同: '修改后认同',
    部分一致: '部分一致',
    去处理: '去处理',
    有测点数据未传回因此本条分数数据仅供参考: '有测点数据未传回，因此本条分数数据仅供参考',
    传感器测点: '传感器测点',
    健康度: '健康度',
    子指标名称: '子指标名称',
    子指标值: '子指标值',
    添加现场检查或维修记录: '添加现场检查或维修记录',
    查看全部: '查看全部',
    维修记录: '维修记录',
    检查记录: '检查记录',
    检修时间: '检修时间',
    诊断提醒: '诊断提醒',
    现场维修: '现场维修',
    现场检查: '现场检查',
    健康诊断分数趋势图: '健康指标诊断分数趋势图',
    振动指标诊断健康分数: '振动指标诊断分数趋势图',
    指标趋势图: '指标趋势图',
    未开机: '未开机',
    智能诊断: '智能诊断',
    门限报警: '门限报警',
    指标监测: '指标监测',
    智能诊断分数趋势: '智能诊断分数趋势',
    指标值对比分析: '指标值对比分析',
    时域波形图: '时域波形图',
    倒频谱图: '倒频谱图',
    交叉相位图: '交叉相位图',
    轴心轨迹图: '轴心轨迹图',
    瀑布图: '瀑布图',
    高频加速度: '高频加速度',
    幅值: '幅值',
    倒频率: '倒频率',
    加载中: '加载中...',
    "智能诊断-指标值及分数导出": '智能诊断-指标值及分数导出',
    "实时监测-指标值导出": '实时监测-指标值导出',
    "事件消息-事件清单导出": '事件消息-事件清单导出',
    "app采集数据- 采集记录导出": 'app采集数据- 采集记录导出',
    "原始波形文件下载": '原始波形文件下载',
    请选择测点: '请选择测点',
    请选择时间范围: '请选择时间范围',
    请选择数据类型: '请选择数据类型',
    开: '开',
    关: '关',
    全设备测点: '全设备测点',
    设备维修: '设备维修',
    设备检查: '设备检查',
    更换部件: '更换部件',
    维护: '维护',
    返厂: '返厂',
    登录: '登录',
    请输入密码: '请输入密码',
    角色名称: '角色名称',
    "[安全退出]": '[安全退出]',
    工单查看: '工单查看',
    小时: '小时',
    小时s: '小时',
    请输入操作记录: '请输入操作记录',
    用户添加: '用户添加',
    暂无数据: '暂无数据',

    变频设备常用转频: '变频设备常用转频',
    是否需要在该测点数据本身找转频: '是否需要在该测点数据本身找转频',
    额定转频: '额定转频',
    是否需要细化频谱: '是否需要细化频谱',
    额定电源频率: '额定电源频率',
    理论转频所在频谱: '理论转频所在频谱',
    转频换算系数: '转频换算系数',
    转频或部件频率上限: '转频或部件频率上限',
    转频或部件频率下限: '转频或部件频率下限',
    包络谱找转频滤波频段下限: '包络谱找转频滤波频段下限',
    转频数据类型: '转频数据类型',
    转频比值: '转频比值',
    叶轮: '叶轮',
    叶轮级数: '叶轮级数',
    叶片数目: '叶片数目',
    轴承: '轴承',
    保持架特征系数: '保持架特征系数',
    滚动体特征系数: '滚动体特征系数',
    外圈特征系数: '外圈特征系数',
    内圈特征系数: '内圈特征系数',
    轴承型号: '轴承型号',
    齿轮箱: '齿轮箱',
    不超过1个: '不超过1个',
    齿轮箱种是否含有蜗轮蜗杆: '齿轮箱种是否含有蜗轮蜗杆',
    齿数: '齿数',
    蜗杆的头数和蜗轮的齿数: '蜗杆的头数和蜗轮的齿数',
    柱塞泵: '柱塞泵',
    不与其他共同选择: '不与其他共同选择',
    柱塞数目: '柱塞数目',
    柱塞泵滤波参数: '柱塞泵滤波参数',
    柱塞泵转频上限: '柱塞泵转频上限',
    柱塞泵转频下限: '柱塞泵转频下限',
    行星齿轮箱: '行星齿轮箱',
    太阳轮齿数: '太阳轮齿数',
    一倍啮合频率: '一倍啮合频率',
    行星轮个数: '行星轮个数',
    "齿轮箱(新的指标提取方式)": '齿轮箱（新的指标提取方式）',
    齿轮齿数: '行星轮个数',
    螺杆齿数: '行星轮个数',
    刀头磨损: '刀头磨损',
    叶片积灰: '叶片积灰',
    异常冲击: '异常冲击',
    异常特征: '异常特征',
    叶轮异常: '叶轮异常',
    冲击烈度: '冲击烈度',
    机械松动: '机械松动',
    滑动轴承松动: '滑动轴承松动',
    基础松动: '基础松动',
    配合松动: '配合松动',
    机械碰摩: '机械碰摩',
    缺水干磨: '缺水干磨',
    配合不良: '配合不良',
    零件磨损: '零件磨损',
    非平稳故障: '非平稳故障',
    气路共振: '气路共振',
    滚动轴承润滑不良: '滚动轴承润滑不良',
    滑动轴承油膜涡动: '滑动轴承油膜涡动',
    滑动轴承油膜振荡: '滑动轴承油膜振荡',
    滑动轴承烧瓦: '滑动轴承烧瓦',
    滑动轴承磨损: '滑动轴承磨损',
    滚动轴承异常: '滚动轴承异常',
    电磁振动: '电磁振动',
    螺杆啮合不良: '螺杆啮合不良',
    行星齿轮啮合不良: '行星齿轮啮合不良',
    转子不对中: '转子不对中',
    转子不平衡: '转子不平衡',
    连杆异常: '连杆异常',
    部件碰摩: '部件碰摩',
    滑阀碰摩: '滑阀碰摩',
    滑块碰摩: '滑块碰摩',
    滑动轴承碰摩: '滑动轴承碰摩',
    陶瓷片脱落: '陶瓷片脱落',
    齿轮啮合不良: '齿轮啮合不良',


    明显发展: '明显发展',
    发展: '发展',
    轻微发展: '轻微发展',
    异常特征减弱: '异常特征减弱',
    有变化: '有变化',
    无明显变化: '无明显变化',
    恢复健康: '恢复健康',
    短暂开机: '短暂开机',
    传输异常: '传输异常',


    振动强度S1: '振动强度S1',
    振动冲击S2: '振动冲击S2',
    振动平衡S3: '振动平衡S3',
    振动极端S4: '振动极端S4',
    振动集中S5: '振动集中S5',
    振动强度S6: '振动强度S6',
    振动强度S7: '振动强度S7',
    振动强度S8: '振动强度S8',
    振动冲击S9: '振动冲击S9',
    振动冲击S10: '振动冲击S10',
    振动集中S11: '振动集中S11',
    振动冲击S12: '振动冲击S12',
    振动强度S13: '振动强度S13',
    振动冲击S14: '振动冲击S14',
    振动冲击S15: '振动冲击S15',
    振动冲击S16: '振动冲击S16',
    振动冲击S17: '振动冲击S17',
    振动平衡S18: '振动平衡S18',
    振动冲击S19: '振动冲击S19',
    振动强度S20: '振动强度S20',
    振动强度S21: '振动强度S21',
    振动强度S22: '振动强度S22',
    振动强度S23: '振动强度S23',
    振动强度S24: '振动强度S24',
    振动强度S26: '振动强度S26',
    振动强度S27: '振动强度S27',
    电流指标S25: '电流指标S25',
    平稳冲击烈度S28: '平稳冲击烈度S28',
    速度均方根S29: '速度均方根S29',
    优化均方根S30: '优化均方根S30',
    优化峰值S31: '优化峰值S31',
    优化峰值: '优化峰值',
    平稳冲击烈度S32: '平稳冲击烈度S32',
    优化峭度S33: '优化峭度S33',
    振动强度S34: '振动强度S34',
    振动强度S35: '振动强度S35',
    振动强度S36: '振动强度S36',
    总设备数: '总设备数',
    设备数: '设备数',
    速度: '速度',
    高频均方根: '高频均方根',
    智能设备大屏: '智能设备大屏',
    设备诊断: '设备诊断',
    系统管理: '系统管理',
    诊断趋势: '诊断趋势',
    标准监测: '标准监测',
    图谱分析: '图谱分析',
    分析工具: '分析工具',
    设备事件: '设备事件',
    设备档案: '设备档案',
    数据下载: '数据下载',

    泵输入端: '泵输入端',
    滚动轴承润滑特征: '滚动轴承润滑特征',
    信号规律性特征: '信号规律性特征',
    "10～25.6KHz均方根": '10～25.6KHz均方根',
    优化峭度: '优化峭度',
    "1～10KHz均方根": '1～10KHz均方根',
    速度均方根: '速度均方根',
    滚动轴承内圈与外圈: '滚动轴承内圈与外圈',
    "泵输入端存在异常特征，判定为滚动轴承异常，故障部位为轴承内圈和外圈，与2022/1/12事件相比，程度进一步发展；请密切关注设备状态与分数变化情况，并结合现场情况适时安排检查。": '泵输入端存在异常特征，判定为滚动轴承异常，故障部位为轴承内圈和外圈，与2022/1/12事件相比，程度进一步发展；请密切关注设备状态与分数变化情况，并结合现场情况适时安排检查。',
    泵端面: '泵端面',
    非平稳故障01: '非平稳故障01',
    非平稳故障02: '非平稳故障02',
    机械碰摩01: '机械碰摩01',
    机械碰摩02: '机械碰摩02',
    缺水干磨01: '缺水干磨01',
    缺水干磨02: '缺水干磨02',
    配合不良01: '配合不良01',
    配合不良02: '配合不良02',
    零件磨损01: '零件磨损01',
    零件磨损02: '零件磨损02',
    峰峰值: '峰峰值',
    频谱集中度: '频谱集中度',
    "0～0.3KHZ均方根": "0～0.3KHZ均方根",
    全频段均方根: '全频段均方根',
    "0～1KHZ均方根": '0～1KHZ均方根',
    偏度因子: '偏度因子',
    缺水干磨主特征: '缺水干磨主特征',
    振动冲击指标12: '振动冲击指标12',
    振动冲击指标19: '振动冲击指标19',
    振动集中指标11: '振动集中指标11',
    平稳冲击烈度: '平稳冲击烈度',
    碰摩总体特征: '碰摩总体特征',
    碰摩次阶特征: '碰摩次阶特征',
    碰摩谐波特征: '碰摩谐波特征',
    碰摩主特征2: '碰摩主特征2',
    叶片低阶特征: '叶片低阶特征',
    叶片中阶特征: '叶片中阶特征',
    不对中低阶特征: '不对中低阶特征',
    不对中中阶特征: '不对中中阶特征',
    不对中轴向特征: '不对中轴向特征',

    '泵输入端：滚动轴承异常；': '泵输入端：滚动轴承异常；',
    '泵输入端：部件碰摩、转子不对中；': '泵输入端：部件碰摩、转子不对中；',
    '泵输入端：滚动轴承异常、转子不对中与部件碰磨': '泵输入端：滚动轴承异常、转子不对中与部件碰磨',
    滚动轴承内圈和外圈: '滚动轴承内圈和外圈',
    "泵端面：部件碰摩；": '泵端面：部件碰摩；',
    "非平稳故障01，非平稳故障02，振动冲击S19。": '非平稳故障01，非平稳故障02，振动冲击S19。',
    "非平稳故障02。": '非平稳故障02。',

    '2号反渗透1号增压泵': '2号反渗透1号增压泵',
    'A线3号超滤循环泵': 'A线3号超滤循环泵',


    滚动轴承损伤: '滚动轴承损伤',
    "非平稳故障01。": "非平稳故障01。",
    "机械碰磨02。": "机械碰磨02。",
    电源谐波特征: '电源谐波特征',
    不平衡主特征: "不平衡主特征",
    优化峭度指标: '优化峭度指标',
    平稳冲击烈度指标: '	平稳冲击烈度指标',
    振动速度均方根指标: '振动速度均方根指标',
    外圈特征: '外圈特征',
    内圈特征: '内圈特征',
    滚动体特征: '滚动体特征',
    保持架特征: '保持架特征',
    振动加速度峰值指标: '振动加速度峰值指标',
    报告总览: '报告总览',
    报告时间: '报告时间',
    事件是否处理: '事件是否处理',
    变化趋势: '变化趋势',
    'Low-frequency acceleration X (m/s2)': '低频加速度X',
    'Low-frequency acceleration Y (m/s2)': '低频加速度Y',
    'Low-frequency acceleration Z (m/s2)': '低频加速度Z',
    'Temperature (°C)': '温度',
    'Velocity X (mm/s)': '速度X',
    'Velocity Z (mm/s)': '速度Z',
    'Velocity Y (mm/s)': '速度Y',
    'High frequency acceleration (m/s2)': '高频加速度',
    "传感器电量": '传感器电量',
    "设备位号": '设备位号',
    "请输入设备位号": '请输入设备位号',
    "设备功率": '设备功率',
    "请输入设备功率": '请输入设备功率',
    "设备ID": '设备ID',
    "请输入设备ID": '请输入设备ID',
    "设备执行人": '设备执行人',
    "请输入设备执行人": '请输入设备执行人',
    "检测类别": '检测类别',
    "在线监测": '在线监测',
    "巡检": '巡检',
    "报告编号": '报告编号',
    "查看报告": "查看报告",
    "设备绑定": "设备绑定",
    "报警内容": '报警内容',
    '发现异常特征，按照巡查计划现场查看设备状态': '发现异常特征，按照巡查计划现场查看设备状态',
    '发现明显异常特征，现场检查设备状态，根据现场检查结果更新维护计划，适时维护设备': '发现明显异常特征，现场检查设备状态，根据现场检查结果更新维护计划，适时维护设备',
    '设备故障严重，建议停机维修': '设备故障严重，建议停机维修',
    '1K～10KHz均方根': '1K～10KHz均方根',
    '10K～25.6KHz均方根': '10K～25.6KHz均方根',
    '分数': '分数',
    '位移峰峰值': '位移峰峰值',
    '巡检阈值管理': '巡检阈值管理',

    '测点名称': '测点名称',
    'FX轴承因子': 'FX轴承因子',
    'FX冲击因子': 'FX冲击因子',
    '执行人': '执行人',

    '啮合冲击': '啮合冲击',
    '星轮磨损': '星轮磨损',
    '滑动轴承润滑不良': '滑动轴承润滑不良',
    '碰磨': '碰磨',
    '磨盘磨损': '磨盘磨损',
    '螺杆啮合不良01': '螺杆啮合不良01',
    '螺杆啮合不良03': '螺杆啮合不良03',
    '螺杆啮合不良02': '螺杆啮合不良02',
    '连杆异常02': '连杆异常02',
    '连杆异常1': '连杆异常1',
    '螺杆碰摩': '螺杆碰摩',
    '巡检序号': '巡检序号',
    '全部报告': '全部报告',
    '报警报告': '报警报告',
    '健康报告': '健康报告',
    '巡检设备细分':'巡检设备细分',
    '智能诊断巡检配置':'智能诊断巡检配置',
    '请选择设备细分':'请选择设备细分',
    '处理状态': '处理状态',
    状态突破笔数:'状态突破笔数',
    是否已放出:'是否已放出',
    笔:'笔',
    '不限':'不限',
    设备门限报警配置: '设备门限报警配置',
    推送配置: '推送配置',
    基础配置: '基础配置',
    OPC变量配置: 'OPC变量配置',
    测点一致性比较: '测点一致性比较',
    测点数据统计: '测点数据统计',
    企业微信模拟推送: 'OPC变量配置',
    监测管理: '监测管理',
    键: '键',
    分类: '分类',
    繁体: '繁体',
    '10～100Hz均方根': '10～100Hz均方根',
    '0.1～10Hz均方根': '0.1～10Hz均方根',
    '10～1000Hz峰值': '10～1000Hz峰值',

  },
  English: {
    '10～100Hz均方根': '10～100Hz RMS',
    '0.1～10Hz均方根': '0.1～10Hz RMS',
    '10～1000Hz峰值': '10～1000Hz peak',
    键: 'key',
    分类: 'Classification',
    '精度': 'Precision',
    '选中': 'Select',
    '公式': 'Formula',
    '公式名称': 'Formula Name',
    '公式内容': 'Formula Content',
    '公式模板': 'Formula Template',
    '数据值': 'Data',
    '变量': 'Variable',
    '测点配置': 'Sensor Configuration',
    '使用公式': 'Use Formula',
    '未使用公式的设备': 'Machines without formulas',
    '已使用公式的设备': 'Machines with formulas',
    '数据转换公式': 'Data Transform Formula',

    监测管理: 'Monitoring management',
    企业微信模拟推送: 'Enterprise WeChat simulated push',
    测点数据统计: 'Point data statistics',
    测点一致性比较: 'Point consistency comparison',
    OPC变量配置: 'OPC variable configuration',
    基础配置: 'Basic configuration',
    推送配置: 'push configuration',
    设备门限报警配置: 'Equipment threshold alarm configuration',
    "语言": "Language",
    "主题": "Theme",
    "蓝色": "Blue",
    "白色": "White",
    "中文": "Chinese",
    "英文": "English",
    "关于": "About",
    '不限':'Unlimited',
    笔:'pen',
    '处理状态': 'Processing status',
    '巡检设备细分': 'Inspection equipment segmentation',
    '智能诊断巡检配置':'Intelligent Diagnostic Inspection Configuration',
'请选择设备细分': 'Please select equipment segmentation',
    '全部报告': 'All reports',
    '报警报告': 'Alarm report',
    '健康报告': 'Health report',
    '巡检序号': 'sort',
    '啮合冲击': 'Meshing Impact',
    '星轮磨损': 'Star Wheel Wear',
    '滑动轴承润滑不良': 'Poor Lubrication of Plain Bearings',
    '碰磨': 'Collision and Abrasion',
    '磨盘磨损': 'Grinding Wheel Wear',
    '螺杆啮合不良01': 'Screw Misalignment 01',
    '螺杆啮合不良03': 'Screw Misalignment 03',
    '螺杆啮合不良02': 'Screw Misalignment 02',
    '连杆异常02': 'Connecting Rod Abnormality 02',
    '连杆异常1': 'Connecting Rod Abnormality 1',
    '螺杆碰摩': 'Screw Abrasion',
    '执行人': 'Executor',
    '位移峰峰值': 'Peak-to-Peak Displacement',
    '测点名称': 'Sensor Name',
    'FX轴承因子': 'FX-Bearing Factor',
    'FX冲击因子': 'FX-Impulsive Factor',

    '基础指标': 'Basic Indicators',
    '合并报告': 'Merged Report',
    '巡检分数趋势': 'Inspection Score Trends',
    '智能诊断报告': 'Intelligent diagnostic report',
    '基础巡检报告': 'Basic Inspection Report',
    '全部测点': 'All Measurement Points',
    '巡检诊断': 'Inspection Diagnosis',
    '巡检状态统计': 'Inspection Status Statistics',
    '巡检设备趋势': 'Inspection Equipment Trends',
    '最新巡检状态': 'Latest Inspection Status',
    '最新巡检日期': 'Latest Inspection Date',
    '巡检报告数量': 'Number of Inspection Reports',
    '巡检设备统计': 'Inspection Equipment Statistics',
    '本周巡检设备数': 'Number of Inspected Equipment this Week',
    '本周巡检设备健康总览': 'Overview of Equipment Health Inspections this Week',
    '加速度均方根': 'Root Mean Square Acceleration',
    '幅值图': 'Amplitude Chart',
    '现场情况': 'On-site Situation',
    '巡检管理': 'Inspection management',
    '巡检统计': 'Inspection Statistics',
    '巡检报告': 'Inspection Report',
    '巡检周报': 'Weekly Inspection Report',
    '巡检状态': 'Inspection Status',
    '巡检日期': 'Inspection Date',
    '日期': 'Date',
    '巡检人': 'Inspector',
    '巡检报告类型': 'Inspection Report Type',
    '请输入设备名称/编号/位号': 'Please enter the equipment name/number/location',
    '基础': 'Basics',
    '智能': 'Smart',

    '动轴承润滑不良': 'Poor Lubrication of Rolling Bearings',
    '列表显示': 'List display',
    '设备运行正常': 'Equipment Operating Normally',
    '全部区域': 'All Areas',
    '台账显示': 'Account display',
    '波形': 'Waveform',
    '压力': 'Pressure',
    '工厂图': 'Factory Map',
    '编辑工厂': 'Edit Factory',
    '新建工厂': 'Create New Factory',
    '更换工厂图': 'Change Factory Map',
    '左键添加标记': 'Left-click to Add Marker',
    '左键按住可拖动': 'Hold Left-click to Drag',
    '右键添加标记': 'Right-click to Add Marker',
    '上级工厂': 'Parent Factory',
    '请填写区域名称': 'Please Enter Area Name',
    '集团不能为自身工厂': 'Group cannot be its own factory',
    '请填写工厂名称': 'Please Enter Factory Name',
    '累计运行': 'Total Runtime',
    '台': 'Units',
    '设备总数': 'Total Equipment',
    '运行数': 'Operating Count',
    '未关注': 'Not Followed',
    '关注': 'Follow',
    '设备清单': 'Equipment List',
    'AI设备卫士': 'AI Condition Monitoring',
    '设备诊断4.0': 'Equipment diagnosis 4.0',
    '设备管理4.0': 'Equipment Management 4.0',
    '报警管理4.0': 'Alarm Management 4.0',
    '报告管理4.0': 'Report Management 4.0',
    '系统配置': 'System Configuration',
    '诊断配置': 'Diagnostic Configuration',
    '知识库': 'Knowledge Base',
    '集团大屏': 'Corporate Dashboard',
    '厂级大屏': 'Factory Dashboard',
    '设备大屏': 'Equipment Dashboard',
    '设备健康总览': 'Equipment Health Overview',
    '诊断分析': 'Diagnostic Analysis',
    '设备列表': 'Equipment List',
    '报警列表': 'Alarm List',
    '硬件监测报警': 'Hardware Monitoring Alarm',
    '智能门限报警配置':'Threshold Alarm Configuration',
    '推送规则': 'Push Rules',
    '专家看护配置': 'Expert Care Configuration',
    '报告管理': 'Report Management',
    '角色管理': 'Role Management',
    '账号管理': 'Account Management',
    '菜单管理': 'Menu Management',
    '工厂配置': 'Factory Configuration',
    '监测范围': 'Monitoring Scope',
    '监控设备数': 'Number of Monitored Equipment',
    '监控测点数': 'Number of Monitoring Points',
    '运行设备数(运行率)': 'Number of Running Equipment (Running Rate)',
    '全厂运行情况': 'Overall Plant Operation',
    '系统持续服务运行 ': 'Continuous System Operation ',
    '全厂运行设备健康分数': 'Overall Plant Equipment Health Score',
    '分数': 'Score',
    '设备健康状态统计': 'Equipment Health Status Statistics',
    '健康': 'Healthy',
    '可用': 'Attention',
    '警戒': 'Alarm',
    '故障': 'Danger',
    '设备运行状态统计': 'Equipment Operation Status Statistics',
    '运行': 'Running',
    '停机': 'Stopped',
    '待机': 'Stopped',
    '设备报警数量统计': 'Equipment Alarm Count Statistics',
    '可用报警': 'Attention Alarms',
    '警戒报警': 'Alarm Alarms',
    '故障报警': 'Danger Alarms',
    '未处理': 'Unprocessed',
    '已关闭': 'Closed',
    '已检修': 'Under Maintenance',
    '本年': 'This Year',
    '本月': 'This Month',
    '本季度': 'This Quarter',
    '本周': 'This Week',
    '各厂报警数量排行': 'Alarm Count Ranking by Factory',
    '显示该系统为工厂上线运行的时间': 'Display the time when the system went online for factory operation',
    '监控设备数：用户所选组织下的监测设备数统计': 'Number of Monitored Equipment: Statistics of monitored Equipment under the selected organization',
    '监控测点数：用户所选组织下的监测测点数统计': 'Number of Monitoring Points: Statistics of monitoring points under the selected organization',
    '运行设备数：用户所选组织下的监测设备中运行设备数统计': 'Number of Running Equipment: Statistics of running Equipment among monitored Equipment under the selected organization',
    '运行率：用户所选组织下的监测设备中运行设备数/监测设备总数': 'Running Rate: Running Equipment count among monitored Equipment under the selected organization divided by the total monitored Equipment count',
    '设备报警趋势': 'Equipment Alarm Trend',
    '设备报警记录': 'Equipment Alarm Records',
    '报警时间': 'Alarm Time',
    '区域清单': 'Zone List',
    '显示单位': 'Zones to Display',
    '监测设备': 'Monitored Equipment',
    '监测测点': 'Monitoring Points',
    '运行设备': 'Running Equipment',
    '报警设备': 'Alarm Equipment',
    '未处理报警': 'Unresolved Alarms',
    '运行率': 'Operation Rate',
    '当前运行状态': 'Current Operating Status',
    '设备厂家': 'Equipment Manufacturer',
    '设备状态占比': 'Equipment Status Percentage',
    '运行占比': 'Operating Percentage',
    '运行时间': 'Operating Time',
    '健康占比': 'Healthy Proportion',
    '健康时间': 'Healthy Time',
    '可用占比': 'Attention Proportion',
    '可用时间': 'Attention-needed Time',
    '警戒占比': 'Alarm Proportion',
    '警戒时间': 'Alarm Time',
    '故障占比': 'Faulty Proportion',
    '故障时间': 'Faulty Time',
    '累计运行时间': 'Total Operating Time',
    '分数趋势': 'Score Trend',
    '报警事件': 'Alarm Events',
    '检修记录': 'Maintenance Records',
    '诊断报醒': 'Diagnostic Alarm',
    '已处理': 'Resolved',
    '请选择设备区域': 'Select Equipment Area',
    '请选择报警类型': 'Select Alarm Type',
    '请选择严重程度': 'Select Severity',
    '下载报警': 'Download Alarm',
    '关闭报警': 'Close Alarm',
    '请选择报警': 'Select Alarm',
    '请选择未处理的报警': 'Select Unresolved Alarm',
    '请填写关闭原因': 'Please Enter Closure Reason',
    '关闭成功': 'Closure Successful',
    '请耐心等待，完成加载后，点击下载即可下载文件，请勿反复点击下载或关闭本网站': 'After loading is complete, click on download to download the file. Please do not click on download repeatedly or close this webpage',
    '有测点数据未传回，因此本条分数数据仅供参考': 'Some measurement point data has not been returned, score data for reference only',
    '请输入设备名称搜索': 'Enter Equipment Name to Search',
    '请输入测点名称搜索': 'Enter Measurement Point Name to Search',
    '设备健康状态': 'Equipment Health Status',
    '综合状态': 'Overall Status',
    '设备基本信息': 'Basic Equipment Information',
    '设备位置': 'Equipment Location',
    '收起': 'Collapse',
    '展开': 'Expand',
    '近两月': 'Last Two Months',
    '设备健康事件时间轴': 'Equipment Health Event Timeline',
    '健康指标诊断分数趋势图': 'Trend Chart of Health Indicator Diagnostic Scores',
    '振动指标诊断分数趋势图': 'Trend Chart of Vibration Indicator Diagnostic Scores',
    '是否显示': 'Show/Hide',
    '显示': 'Show',
    '隐藏': 'Hide',
    '开关机线': 'Equipment ON/OFF Line',
    '运行时间趋势': 'Trend of Runtime',
    '指标监测趋势': 'Trend of Metric Monitoring',
    '指标值': 'Metric Value',

    '检修事件': 'Maintenance Event',
    '添加检修记录': 'Add Maintenance Record',
    '批量关闭报警': 'Dismiss Alarms in Batch',
    '排序': 'Sort',
    '事件类型': 'Event Type',
    '诊断报警': 'Diagnostic Alarm',
    '请选择健康状态': 'Select Health Status',
    '运行状态': 'Operating Status',
    '请选择运行状态': 'Select Operating Status',
    '请输入设备名称/编号': 'Enter Equipment Name/Number',
    '新建设备': 'New Equipment',
    '测点列表': 'List of Monitoring Points',
    '设备序号': 'Equipment Number',
    '是否实验台': 'Is Experimental Platform',
    '请选择是否为试验台': 'Please select if it is a test bench',
    '所属工厂': 'Belongs to Factory',
    '报警记录': 'Alarm Records',
    '健康总览': 'Health Overview',
    '测点位置': 'Point Location',
    '请输入测点位置': 'Enter Point Location',
    '新建测点': 'Create New Point',
    '编辑设备': 'Edit Equipment',
    '设备照片': 'Equipment Photo',
    '故障信息': 'Danger Information',
    '故障详情': 'Danger Details',
    '检修照片': 'Maintenance Photo',
    '诊断设备': 'Diagnose Equipment',
    '建议及措施': 'Recommendations and Measures',

    '编辑测点': 'Edit Point',
    '请输入传感器SN': 'Please enter sensor SN',
    '请输入安装位置': 'Please enter installation location',
    '转频提取': 'Speed Extraction',
    '请选择转频提取测点': 'Please select speed extraction point',
    '请选择设备类型': 'Please select equipment type',
    '请选择功率': 'Please select power',
    '请输入编号': 'Please enter number',
    '请输入安装坐标': 'Please enter installation coordinates',
    '请输入轴名称': 'Please enter axis name',
    '测点照片': 'Point Photo',
    '请输入备注': 'Please enter a note',
    '水平径向': 'Horizontal Radial',
    '竖直径向': 'Vertical Radial',
    '传感器编号': 'Sensor Number',
    '轴名称': 'Axis Name',
    '编号': 'Number',
    '测点ID': 'Monitoring Point ID',
    '是否试验台': 'Whether it is a test bench',
    '总貌图': 'Overview Image',
    '左键按住可拖动，右键添加标记': 'Left-click to drag, right-click to add a mark',
    '关闭原因': 'Reason for Closure',
    '旋转': 'Rotate',
    '更换3D图': 'Change 3D Image',
    '更换2D图': 'Change 2D Image',

    '选择设备区域': 'Select Equipment Area',
    '选择严重程度': 'Select Severity Level',
    '请输入关键词搜索': 'Enter Keyword for Search',
    '检修详情': 'Maintenance Details',
    '开始时间': 'Start Time',
    '结束时间': 'End Time',
    '检修人员': 'Maintenance Personnel',
    '现场设备状态': 'On-site Equipment Status',
    '故障描述': 'Fault Description',
    '健康设备': 'Healthy Equipment',
    '可用设备': 'Equipment requesting Attentions',
    '警戒设备': 'Equipment under Alarms',
    '故障设备': 'Equipment with Faults',
    '分析周期': 'Analysis Period',
    '故障模式统计(本年)': 'Failure Mode Statistics (This Year)',

    '本周检修/检查': 'Maintenance/Inspection this Week',
    '本月检修/检查': 'Maintenance/Inspection this Month',
    '周报转发：复制链接转发，用户可在电脑端或手机端查看': 'Weekly Report Forwarding: Copy the link to forward, users can view it on a computer or mobile equipment',
    '手机端链接': 'Mobile Equipment Link',
    '参数配置': 'Parameter Configuration',
    '操作日志': 'Operation Log',
    '登录日志': 'Login Log',
    '数据变更日志': 'Data Change Log',
    '数采器列表': 'Data Acquisition Unit List',
    '传感器监测': 'Sensors',
    "采集单元监测": "Edge Gateways",
    '服务监测': 'Service Monitoring',
    '系统监测报警': 'System Monitoring Alarm',
    '工况对接配置': 'Operating Condition Interface Configuration',
    '周报配置': 'Weekly Report Configuration',

    '智能诊断报警配置': 'Smart Diagnostic Alarm Configuration',
    '标准监测报警配置': 'Standard Monitoring Alarm Configuration',
    '非标设备管理': 'Non-Standard Equipment Management',
    '设备首页': 'Equipment Homepage',

    '三级菜单测试第二级': 'Test Third-Level Menu 2',
    '三级菜单测试第三级': 'Test Third-Level Menu 3',
    '设备事件报警': 'Equipment Event Alarm',

    '测试三级2': 'Test Third-Level 2',
    '故障标准库': 'Fault Standard Library',
    '3D模型库': '3D Model Library',
    '开关机配置': 'Power On/Off Configuration',
    '采集器列表': 'Data Collector List',

    '昵称/用户名/手机号': 'Nickname/Username/Phone Number',
    '请选择所属工厂': 'Please Select the Affiliated Factory',
    '配置': 'Configuration',
    '配置权限': 'Configure permissions',
    '输入用户名': 'Enter Username',
    '输入昵称': 'Enter Nickname',
    '不修改密码无需输入': 'No need to enter if not changing password',
    '请输入角色名称': 'Please Enter the Role Name',
    '请选择菜单': 'Please Select Menu',
    '请选择工厂权限': 'Please Select Factory Permissions',
    '工厂权限': 'Factory Permissions',
    '确定删除此条数据么': 'Are you sure you want to delete this data',

    '菜单名称': 'Menu Name',
    '菜单路由': 'Menu Route',
    '菜单Code': 'Menu Code',
    '上级菜单': 'Parent Menu',
    '菜单类型': 'Menu Type',
    '按钮': 'Button',
    '链接': 'Link',
    '路由地址': 'Route Address',
    '请输入路由地址': 'Please Enter Route Address',
    '菜单排序': 'Menu Order',
    '菜单状态': 'Menu Status',
    '一级菜单': 'One-level menu',

    '定位': 'Positioning',
    '集团': 'Group',
    '请选择集团': 'Please Select Group',

    '故障释义': 'Fault Explanation',
    '一级分类': 'Primary Classification',
    '请输入一级分类': 'Please Enter Primary Classification',
    '二级分类': 'Secondary Classification',
    '请输入二级分类': 'Please Enter Secondary Classification',
    '三级分类': 'Tertiary Classification',
    '请输入三级分类': 'Please Enter Tertiary Classification',
    '缩写': 'Abbreviation',
    '请输入缩写': 'Please Enter Abbreviation',
    '模型图': 'Model Diagram',
    '输入区域或设备名称筛选': 'Enter Area or Equipment Name for Filtering',
    '未选择设备或没有配置测点': 'No Equipment Selected or No Monitoring Points Configured',
    '粘贴': 'Paste',
    '确定删除所选数据么': 'Do you want to delete the selected data',
    '请选择复制的内容': 'Please select the content to copy',
    '不允许粘贴': 'Paste not allowed',
    '没有复制的内容': 'No content copied',
    '请选择内容': 'Please select content',
    '振动参数': 'Vibration parameters',
    '请选择项目': 'Please select an item',
    '诊断工单(待完成)': 'Diagnostic work order (pending)',
    '诊断工单(已完成)': 'Diagnostic work order (completed)',
    '确认删除': 'Confirm deletion',
    '请填写诊断判断备注': 'Please fill in diagnostic judgment remarks',
    '保存任务处理': 'Save task processing',
    '请输入切片数': 'Enter the number of slices',
    '请选择工厂后提交': 'Please select the factory before submitting',
    '周报月报配置': 'Weekly and monthly report configuration',
    '报告生成策略': 'Report generation strategy',
    '是否生成报告': 'Generate report',
    '每月第': 'Every month on the',
    '每周第': 'Every week on the',
    '天生成月报': 'day generate monthly report',
    '天生成周报': 'day generate weekly report',
    '星期一': 'Monday',
    '星期二': 'Tuesday',
    '星期三': 'Wednesday',
    '星期四': 'Thursday',
    '星期五': 'Friday',
    '星期六': 'Saturday',
    '星期日': 'Sunday',

    '第': 'On the',
    '小时生成报告': 'hour generate report',

    '故障信息(请勾选此次维修的故障项)': 'Fault information (please select the faults for this repair)',
    '维修详情': 'Repair details',
    '故障信息(请勾选此次关闭的故障项)': 'Fault information (please select the faults to be closed this time)',
    '检修图片': 'Maintenance pictures',
    '请选择开始时间': 'Please select start time',
    '请选择结束时间': 'Please select end time',
    '请填写检修人员': 'Please fill in maintenance personnel',
    '请选择现场设备状态': 'Please select on-site equipment status',
    '请填写故障原因': 'Please fill in the cause of the fault',
    '请填写检修内容': 'Please fill in maintenance content',
    '新增成功': 'Added successfully',
    '请选择关闭的故障项': 'Please select the faults to be closed',
    '低频加速度X(m/s2)': 'Low frequency acceleration X (m/s2)',
    '低频加速度Y(m/s2)': 'Low frequency acceleration Y (m/s2)',
    '低频加速度Z(m/s2)': 'Low frequency acceleration Z (m/s2)',
    '温度(­°C)': 'Temperature (°C)',
    '温度(°C)': 'Temperature (°C)',
    '速度X(mm/s)': 'Velocity X (mm/s)',
    '速度Z(mm/s)': 'Velocity Z (mm/s)',
    '速度Y(mm/s)': 'Velocity Y (mm/s)',
    '高频加速度(m/s2)': 'High frequency acceleration (m/s2)',

    '低频加速度X': 'Low frequency acceleration X',
    '低频加速度Y': 'Low frequency acceleration Y',
    '低频加速度Z': 'Low frequency acceleration Z',
    '速度X': 'Velocity X',
    '速度Z': 'Velocity Z',


    '健康设备数': 'Healthy equipment \n count',
    '可用设备数': 'Equipment reqesting attentions\n count',
    '警戒设备数': 'Equipment under alarms \n count',
    '故障设备数': 'Equipment with faults \n count',
    '停机设备数': 'Stopped equipment \n count',
    '待机设备数': 'Stopped equipment \n count',
    '运行设备数': 'Running equipment \n count',

    '高频加速度(长)': 'High frequency acceleration(long)',
    '速度Y': 'Velocity Y',
    '趋势图': 'Trend chart',
    '时域图': 'Time domain chart',
    '有效值': 'Effective value',
    '倍频': 'Harmonic',
    '边频': 'Sideband',
    '清空标注': 'Clear annotations',
    '值': 'Value',
    '暂无下载文件': 'No files available for download',

    '频谱': 'Spectrum',
    '选择范围': 'Select range',
    '包络解调': 'Enveloping demodulation',
    '采样时间': 'Sampling time',
    '振动指标-均方根': 'Vibration indicator-RMS',
    '振动指标-0~0.3KHz均方根': 'Vibration indicator-0~0.3KHzRMS',
    '振动指标-0~1KHz均方根': 'Vibration indicator-0~1KHzRMS',
    '振动指标-1K~10KHz均方根': 'Vibration indicator-1K~10KHzRMS',
    '振动指标-10K~25.6KHz均方根': 'Vibration indicator-10K~25.6KHzRMS',
    '振动指标-1K~25.6KHz均方根': 'Vibration indicator-1K~25.6KHzRMS',
    '振动指标-0~25.6KHz均方根': 'Vibration indicator-0~25.6KHzRMS',
    '振动指标-优化峭度01': 'Vibration indicator-Optimized kurtosis 01',
    '振动指标-平稳冲击烈度': 'Vibration indicator-Smoothed impulsive intensity',
    '振动指标-线性峭度02': 'Vibration indicator-Linear kurtosis 02',
    '振动指标-峭度因子': 'Vibration indicator-Kurtosis factor',
    '振动指标-峰峰值': 'Vibration indicator-Peak-to-peak value',
    '振动指标-优化峰值': 'Vibration indicator-Optimized peak value',
    '振动指标-优化偏度': 'Vibration indicator-Optimized skewness',
    '振动指标-速度均方根': 'Vibration indicator-Velocity RMS',
    '振动指标-频率集中度': 'Vibration indicator-Frequency concentration',
    '振动指标-0.3~1KHz均方根': 'Vibration indicator-0.3~1KHzRMS',
    '振动指标-1K~3KHz均方根': 'Vibration indicator-1K~3KHzRMS',
    '振动指标-3K~6KHz均方根': 'Vibration indicator-3K~6KHzRMS',
    '振动指标-6K~12KHz均方根': 'Vibration indicator-6K~12KHzRMS',
    '振动指标-12000~25600Hz均方根': '振动Vibration indicator指标-12000~25600HzRMS',
    '振动指标-6K~10KHz均方根': 'Vibration indicator-6K~10KHzRMS',
    '振动指标-优化均方根': 'Vibration indicator-Optimized RMS',
    '振动指标-偏度因子': 'Vibration indicator-Skewness factor',
    '振动指标-裕度因子': 'Vibration indicator-Kurtosis factor',
    '振动指标-峰值指标': 'Vibration indicator-Peak value index',
    '振动指标-包络信息熵': 'Vibration indicator-Envelope entropy',
    '振动指标-包络幅值峭度': 'Vibration indicator-Envelope amplitude kurtosis',
    '振动指标-脉冲因子': 'Vibration indicator-Impulse factor',
    '振动指标-波形因子': 'Vibration indicator-Waveform factor',
    '振动指标-均值频率': 'Vibration indicator-Mean frequency',
    '振动指标-主频带位置': 'Vibration indicator-Main frequency band position',
    '振动指标-时域信息熵': 'Vibration indicator-Time domain entropy',
    '振动指标-频域信息熵': 'Vibration indicator-Frequency domain entropy',
    '振动指标-电流指标': 'Vibration indicator-Current index',
    '趋势波形图': 'Trend waveform chart',
    '多时域频谱': 'Multi-time domain spectrum',
    '诊断分数趋势': 'Diagnostic score trend',
    '倒频谱': 'Inverse spectrum',


    '幅值-m/s²': 'Amplitude - m/s²',
    '频率-Hz': 'Frequency - Hz',
    '振动指标-Trms': 'Vibration indicator-Trms',
    '振动指标-Trms_300': 'Vibration indicator-Trms_300',
    '振动指标-Trms_1000': 'Vibration indicator-Trms_1000',
    '振动指标-Trms_1000_10000': 'Vibration indicator-Trms_1000_10000',
    '振动指标-Trms_10000_25600': 'Vibration indicator-Trms_10000_25600',
    '振动指标-Trms_1000_25600': 'Vibration indicator-Trms_1000_25600',
    '振动指标-TLinKurt': 'Vibration indicator-TLinKurt',
    '振动指标-TImpactIntensity': 'Vibration indicator-TImpactIntensity',
    '振动指标-Tlin_kurt': 'Vibration indicator-Tlin_kurt',
    '振动指标-Tkurt': 'Vibration indicator-Tkurt',
    '振动指标-Tff': 'Vibration indicator-Tff',
    '振动指标-TAccelerationPeak': 'Vibration indicator-TAccelerationPeak',
    '振动指标-Tlin_bias': 'Vibration indicator-Tlin_bias',
    '振动指标-TVelocityRMS': 'Vibration indicator-TVelocityRMS',
    '振动指标-Tcon': 'Vibration indicator-Tcon',
    '振动指标-Trms_300_1000': 'Vibration indicator-Trms_300_1000',
    '振动指标-Trms_1000_3000': 'Vibration indicator-Trms_1000_3000',
    '振动指标-Trms_3000_6000': 'Vibration indicator-Trms_3000_6000',
    '振动指标-Trms_6000_12000': 'Vibration indicator-Trms_6000_12000',
    '振动指标-Trms_12000_25600': 'Vibration indicator-Trms_12000_25600',
    '振动指标-Trms_6000_10000': 'Vibration indicator-Trms_6000_10000',
    '振动指标-TAccelerationRMS': 'Vibration indicator-TAccelerationRMS',
    '振动指标-Tbias': 'Vibration indicator-Tbias',
    '振动指标-Tmargin': 'Vibration indicator-Tmargin',
    '振动指标-Tpp': 'Vibration indicator-Tpp',
    '振动指标-Tent_e': 'Vibration indicator-Tent_e',
    '振动指标-Tenv_kurt': 'Vibration indicator-Tenv_kurt',
    '振动指标-Tpulse': 'Vibration indicator-Tpulse',
    '振动指标-Twave': 'Vibration indicator-Twave',
    '振动指标-TF9': 'Vibration indicator-TF9',
    '振动指标-Tmainf': 'Vibration indicator-Tmainf',
    '振动指标-Tent_t': 'Vibration indicator-Tent_t',
    '振动指标-Tent_f': 'Vibration indicator-Tent_f',
    '振动指标-Tcurrent': 'Vibration indicator-Tcurrent',



    'Low frequency acceleration X (m/s2)': '低频加速度X(m/s2)',
    'Low frequency acceleration Y (m/s2)': '低频加速度Y(m/s2)',
    'Low frequency acceleration Z (m/s2)': '低频加速度Z(m/s2)',
    'Temperature (°C)': '温度(°C)',
    'Velocity X (mm/s)': '速度X(mm/s)',
    'Velocity Z (mm/s)': '速度Z(mm/s)',
    'Velocity Y (mm/s)': '速度Y(mm/s)',
    'High frequency acceleration (m/s2)': '高频加速度(m/s2)',
    'Low frequency acceleration X': '低频加速度X',
    'Low frequency acceleration Y': '低频加速度Y',
    'Low frequency acceleration Z': '低频加速度Z',
    'Temperature': '温度',
    'Velocity X': '速度X',
    'Velocity Z': '速度Z',
    'Velocity Y': '速度Y',
    'High frequency acceleration': '高频加速度',
    
    '设备生命周期管理': 'Equipment Lifecycle Management',

    电机驱动端: 'Motor drive end',
    一轴输入端: 'One shaft input',
    一轴输出端: 'One shaft output',
    二轴输入端: 'Two-shaft input',
    二轴输出端: 'Two-shaft output',
    三轴输出端: 'Three-shaft output',
    滚筒轴承: 'Roller bearings',

    左侧滚筒轴承: 'Left roller bearing',
    左侧电机驱动端: 'Left motor drive end',
    三轴输入端: 'Three-shaft input',
    四轴左侧输出端: 'Four-shaft left output',
    四轴右侧输出端: 'Four-shaft right output',
    右侧滚筒轴承: 'Right roller bearing',
    一轴左侧输入端: 'One shaft left input',
    一轴右侧输入端: 'One shaft right input',
    右侧电机驱动端: 'Right motor drive end',

    四轴输出端: 'Four-shaft input',
    五轴输出端: 'Five-shaft input',


    查看详情: 'View details',
    返回机房: 'Return to the machine room',
    暂无事件: 'No event',
    条: 'Pieces',
    查看更多: 'View More',
    点击查看详情: 'Click for details',
    机房: 'The machine room',
    健康指标: 'Health indicators',
    振动指标: 'Vibration indicator',
    分: 'Score',
    系统持续服务运行: "Continuous service operation of the system",
    区域健康评分: 'Zone Health score',
    '针对运行中的设备, 状态得分的加权平均数计算为全厂健康分数, 健康设备记100分, 可用设备记80分, 警戒设备记60分, 故障设备记30分': 'For the equipment in operation, the weighted average of status points is calculated as the factory Health score , with 100 points for healthy equipment, 80 points for attention-needed equipment, 60 points for Alarm equipment, and 30 points for Danger equipment',
    传感器安装位置: 'Sensor mounting position',
    转速: 'Rotational speed',
    时间: 'Time',
    操作: 'Operation',
    下载: 'Download',
    条数据: 'Pieces of data',
    请耐心等待完成加载后点击确认即可下载文件请勿反复点击下载或关闭本网站: 'Please wait patiently. After the loading is complete, click OK to download the file. Please do not click download repeatedly or close this website',
    共: 'Totally',
    近一天: 'since yesterday',
    近一周: 'last week',
    近一月: 'last month',
    自定义: 'Customize',
    筛选: 'Filter',
    自动刷新: 'Auto refresh',
    关闭: 'Off',
    开启: 'On',
    工况数据: 'Operating data',
    工况名称: 'Operating condition name',
    工况值: 'Operating value',
    工况信息图表: 'Operating condition infographic',
    全部设备: 'All equipment',
    搜索: 'Search',
    搜索设备信息: 'Search equipment information',
    设备名称: 'Equipment name',
    设备区域: 'Equipment area',
    安装位置: 'Installation location',
    当前状态: 'Current status',
    健康状态描述: 'Description of Health status',
    状态: 'Status',
    分数等级: 'Score grade',
    建议客户的行为: 'Suggested customer behavior',
    建议使用时间: 'Recommended using time',

    可用上: 'Upper Attention',
    可用下: 'Lower Attention',
    警戒上: 'Slight Alarm',
    警戒中: 'Medium Alarm',
    警戒下: 'Severe Alarm',
    故障上: 'Slight Danger',
    故障下: 'Severe Danger',
    无: 'None',
    无需操作: 'No action required',
    可持续使用: 'Sustainable use',
    一级可用: 'Level 1 Attention',
    二级可用: 'Level 2 Attention',
    一级警戒: 'Alarm level 1',
    二级警戒: 'Alarm level 2',
    发现异常特征关注AI设备卫士中设备分数变化趋势: 'Discover abnormal features and pay attention to the trend of equipment scores in AI equipment guards',
    发现异常特征按照巡查计划现场查看设备状态: 'Abnormal features are found, and the equipment status is checked on site according to the inspection plan',
    天07内查看: 'View within 0-7 days',
    具体时间因设备和故障类型而异: 'Exact times vary by equipment and types of fault',
    发现明显异常特征现场检查设备状态根据现场检查结果更新维护计划: 'Find obvious abnormal features, check the status of the equipment on site, and update the maintenance plan according to the results of the on-site inspection',
    天03内检查天170内维护: 'Inspection within 0-3 days, maintenance within 1-70 days',
    发现明显异常特征现场检查设备状态制定维护计划适时维护设备: 'Find obvious abnormal features, check the status of equipment on site, formulate maintenance plans, and maintain equipment in a timely manner',
    天03内检查天130内维护: 'Inspection within 0-3 days, maintenance within 1-30 days',
    停止运行机器进行维护: 'Shut down the machine for maintenance',
    尽快停机: 'Shut down as soon as possible',
    健康状态: 'Health status',
    运行中: 'Running',
    已停止: 'Stopped',
    查看: 'Check',
    诊断报告: 'Diagnose report',
    检修报告: 'Maintenance Report',
    设备详情: 'Equipment details',
    设备型号: 'Equipment model',
    设备品牌: 'Equipment brand',
    添加日期: 'Add date',
    设备描述: 'Equipment description',
    个人报告: 'Personal report',
    周报月报: 'Weekly/Monthly report',
    账户管理: 'Account management',

    报警管理: 'Alarm Management',
    状态监测报警: 'Status monitoring alarm',
    智能诊断报警: 'Intelligent diagnosis alarm',
    智能诊断模型配置: 'Smart diagnosis dodel configuration',
    工厂设备管理: 'Factory equipment management',
    设备管理: 'Equipment management',
    测点管理: 'Measuring point management',

    系统日志: 'System log',
    日志管理: 'Log management',
    访问日志: 'Access log',
    工况触发采集配置: 'Condition trigger collection configuration',
    工况数据管理: 'Operating condition data management',
    工况采集卡管理: 'Operating condition capture card management',
    有线采集卡管理: 'Wired capture card management',
    诊断管理: 'Diagnostic management',
    模型配置: 'Model configuration',
    诊断工单管理: 'Diagnostic worksheet management',
    稳定状态清空: 'Steady-state clearing',
    数据清洗配置: 'Data cleaning configuration',
    搜索设备信息报告内容等: 'Search for equipment information, report content, and more',
    选择日期: 'Select date',
    设备: 'Equipment',
    诊断描述: 'Diagnostic description',
    严重程度: 'Severity degree',
    最近更新: 'Recently updated',
    轻微: 'Slightly',
    中度: 'Moderate',
    严重: 'Severity',
    诊断详情: 'Diagnostic details',
    健康事件: 'Health event',
    可用事件: 'Attention events',
    警戒事件: 'Alarm event',
    故障事件: 'Danger event',
    幅值谱图: 'Amplitude spectrum',
    包络谱图: 'Envelope demodulation',
    故障原因: 'Cause of failure',
    备注: 'Remark',
    报告状态: 'Report status',
    数据源: 'Data source',
    提交日期: 'Submission date',
    已诊断: 'Diagnosed',
    诊断中: 'Diagnosing',
    个人申请: 'Individual application',
    巡检记录: 'Inspection record',
    异常数据报警: 'Abnormal data alarm',
    个人报告信息: 'Personal report information',
    诊断中请耐心等待: 'Diagnosing, please wait patiently',
    当前设备问题严重程度为重度请及时进行检查与维修: 'The severity of the problem is serious. Please check and maintain the equipment in time',
    当前设备问题严重程度为中度请密切关注请结合现场情况适时检查: 'The severity of the current equipment fault is moderate. Pay close attention to the problem and check it according to the onsite situation.',
    当前设备问题严重程度为轻度请关注: 'The severity of the current equipment problem is mild. Please pay attention.',
    诊断结论: 'Diagnostic conclusion',
    报告内容: 'Report content',
    现场照片: 'Site photos',
    未上传: 'Have not uploaded',
    设备信息: 'Equipment information',
    检修日期: 'Maintenance date',
    检修内容: 'Maintenance content',
    故障类型: 'Fault type',
    检修人: 'Maintenance person',
    提交时间: 'Submission time',
    检修报告详情: 'Inspection report details',
    检修结果: 'Inspection result',
    综合健康状态: 'Overall Health status',
    当前设备分数: 'Current equipment status',
    现场设备状态判断: 'On-site equipment status judgment',
    现场反馈详情: 'On-site feedback details',
    故障模式: 'Fault mode',
    一致性: 'Consistency',
    一致: 'Unanimous',
    不确定: 'Uncertain',
    不一致: 'Inconformity',
    操作记录: 'Operation record',
    检修信息: 'Maintenance information',
    报告标题: 'Report title',
    报告周期: 'Reporting cycle',
    报告类型: 'Report type',
    周: 'Week',
    月报: 'Monthly report',
    周报: 'Weekly report',
    报告统计时间: 'Report statistics time',
    报告日期: 'Date of report',
    设备详情清单: 'Equipment details list',
    取消: 'Cancel',
    保存: 'Save',
    设备状态: 'Equipment status',
    状态变化: 'State change',
    诊断结果: 'Diagnostic result',
    未知因素: 'Unknown factor',
    本周检修检查: "This week's overhaul/inspection",
    pc端链接: 'Computer web link',
    移动端链接: 'Mobile web link',
    周报转发分别复制链接转发用户可在电脑端或手机端查看: 'Weekly report forwarding: copy link forwarding respectively, users can view on the computer or mobile phone',
    本周设备健康总览: 'Overview of equipment Health this week',
    本周设备事件提醒总览: "Overview of this week's equipment event notifications",
    故障模式统计本年: 'Fault mode statistics (current year)',
    有线采集管理: 'Wired acquisition management',
    成功: 'Succeed',
    失败: 'Failure',
    添加账户: 'Add account',
    昵称: 'Nickname',
    用户名: 'Username',
    角色: 'Role',
    手机号: 'Mobile Number',
    邮箱: 'Email',
    是否启用: 'Enable or not',
    权限标签: 'Permission label',
    关键词: 'Key words',
    昵称用户名手机号: 'Nickname/Username/Mobile Number',
    全部: 'All',
    是: 'Yes',
    否: 'No',
    编辑: 'Edit',
    停用: 'Disabled',
    启用: 'Enable',
    重置密码: 'Reset password',
    修改密码: 'Change password',
    修改账户: 'Modify account',
    请输入用户名: 'Please enter username',
    请输入昵称: 'Please enter nickname',
    账号: 'Username',
    密码: 'Password',
    验证码:'Captcha',
    密码至少8位: 'Password cannot be less than 8 characters',
    随机生成: 'Randomly generated',
    请选择角色: 'Please select role',
    工厂: 'Factory',
    请输入手机号: 'Please enter mobile Number',
    请选择工厂: 'Please select factory',
    请选择: 'Please select',
    确定: 'Confirm',
    重置该用户密码: 'Reset the user password',
    新密码: 'New password',
    旧密码: 'Old password',
    角色名: 'Character name',
    查询: 'Inquire',
    菜单: 'Menu',
    删除: 'Delete',
    新增: 'Add',
    确认删除该角色: 'Confirm to delete this role!',
    保存成功: 'Saved successfully !',
    保存失败: 'Fail to save !',
    编辑成功: 'Edit successfully !',
    操作成功: 'Successful operation !',
    区域: 'Area',
    设备id: 'Equipment ID',
    设备类型: 'Equipment type',
    厂家: 'Factory',
    型号: 'Model',
    机器SN号: 'Machine SN',
    序号: 'Serial number',
    是否是试验台: 'Is it a test-bed',
    传感器位置: 'Sensor location',
    设备类型缩写: 'Equipment type abbreviation',
    生产厂家: 'Manufacturer',
    设备SN号: 'Equipment SN',
    试验台: 'Test-bed',
    版本: 'Version',
    旗舰版: 'Ultimate edition',
    商业版: 'Business edition',
    设备图片: 'Equipment pictures',
    上传: 'Upload',
    提交: 'Submit',
    请输入: 'Please enter',
    操作失败: 'Operation failure',
    文件上传失败请联系管理员: 'File upload failed. Please contact the administrator',
    传感器SN: 'Sensor SN',
    测点id: 'Measuring point ID',
    当前设备: 'Current equipment',
    转频提取测点: 'Frequency conversion extraction measurement point',
    轴参数: 'Axis parameters',
    DT编号: 'DT number',
    安装坐标: 'Installation coordinates',
    名称: 'Name',
    报警类型: 'Alarm type',
    高频: 'High frequency',
    低频: 'Low frequency',
    路径: 'Route',
    更新时间: 'Updated time',
    当前值: 'Current value',
    特性: 'Peculiarity',
    所属设备: 'Equipment',
    功率: 'Power',
    三轴参数: 'Triaxial parameters',
    数据类型: 'Type of data',
    默认展示数据类型: "The data type is displayed by default",
    保存路径: 'Save route',
    上次更新: 'Last update',
    添加: 'Add',
    选择: 'Select',
    搜索测点信息: 'Search measuring point information',
    是否推送: 'Push or not',
    推送人: 'Pusher',
    清空: 'Empty',
    说明: 'Illustrate',
    测点: 'Measuring point',
    指标名称: 'Indicator name',
    单位与描述: 'Unit and description',
    一级门限可用: 'Level 1 threshold - attention',
    报警间隔天: 'Alarm interval - Days',
    二级门限警戒: 'Level 2 threshold - alarm',
    三级门限故障: 'Level 3 threshold - danger',
    不推送: 'Do not push',
    确认: 'Confirm',
    同步标准: 'Synchronization standard',
    基于国际国家或行业内既定标准实现对设备运行状态进行监测同时可纵向参考设备历史运行数据横向比较同类设备运行数据确定各报警等级的阈值: 'Based on international, national or industry-established standards, the monitoring of equipment operating status is realized. at the same time. It can refer to the historical operation data of equipment vertically, compare the operation data of similar equipment horizontally, and determine the threshold value of each alarm level.',
    但依据标准设定的绝对合理的阈值很难获取设定过高的报警阈值会造成设备故障: 'However, it is difficult to obtain an absolutely reasonable threshold set according to the standard. If the alarm threshold is set too high, it will cause the omission risk of equipment',
    漏报: 'Fault reporting',
    的风险而阈值过低又会来带大量的: ', and if the threshold is too low, it will bring a large number of ',
    误报警: 'False alarms',
    给现场处理造成极大的压力此外仅按照标准规定中的几种指标设定的阈值报警所能发现的故障模式有限设置和修改阈值也面临必需手动调整与工作量大等问题: ', which will cause great damage to the on-site processing. pressure; in addition, the fault modes that can be detected only by the threshold alarms set by several specified in the standard regulations are limited. Setting and modifying the threshold also faces problems such as manual adjustment and heavy workload.',
    根据各类国际国家行业标准根据对目前所有设备类型参照相应标准做如下统计: 'According to various international, national and industry standards, and according to all current equipment types, referring to the corresponding standards, the following statistics are made:',
    采用标准: 'Standard',
    电机类: 'Motor series',
    泵类: 'Pump series',
    往复类: 'Reciprocating series',
    风机类: 'Fan series',
    齿轮类: 'Gears series',
    螺杆式: 'Screw series',
    汽轮机: 'Steam turbine',
    通用设备: 'General equipment',
    报警策略: 'Alarm strategy',
    工况异常处理: 'Working condition exception handling',
    是否专家看护: 'Expert care or not',
    是否专家认证: 'Is the expert certified',
    分指标报警: 'Sub-indicator alarm',
    按设备整体状态: 'According to the overall status of the equipment',
    单点即刻报警: 'Single point instant alarm',
    短期重复出现报警: 'Short-term recurring alarms',
    智能诊断报警策略组合: 'Intelligent diagnosis and alarm strategy combination',
    一旦监测到分数异常即刻报警: 'Once abnormal scores are detected, send alarms immediately',
    统计短期内重复出现同类型异常报警去除工况突变数据采集等异常值误报: 'Count the repeated occurrence of the same type of abnormal alarms in a short period of time, and remove abnormal value false alarms such as sudden changes in working conditions and data collection',
    每个指标发生分数恶化都单独发送报警: 'Score deterioration for each index sends separate alarms',
    适合处于非健康状态或指标磨合期的设备需要故障模式报警: 'Suitable for equipment that is in an unhealthy state or in the run-in period of indicators, and requires fault mode alarms',
    适合运行较稳定需要故障模式报警: 'Suitable for relatively stable operation, requiring fault mode alarm',
    仅当设备整体状态恶化时发送报警: 'Send alarms only when the overall condition of the equipment deteriorates',
    用于对整体设备状态监测非健康设备报警时效性要求高: 'Be used to monitor the overall equipment status, and the alarm timeliness of non-healthy equipment is high',
    用于对整体设备状态监测设备运行较稳定趋势性变化突发异常概率低: 'Be used to monitor the overall equipment status, the equipment runs relatively stable, and the probability of sudden abnormalities in trend changes is low',
    笔内出现: 'Inside the pen, appear',
    次: 'times',
    开关机影响时间范围: 'Shutdown affected time range',
    分钟: 'minutes',
    范围: 'scope',
    状态回升灵敏度: 'Status recovery sensitivity',
    距最近开机: 'since last turn on',
    笔数据判断状态向前: 'Pen data judgment status, forward',
    笔数据判断状态: 'Pen data judgmenta factory before submitting!',
    请选择区域后再提交: 'Please select a region before submitting!',
    请选择设备后再提交: 'Please select  status.',
    请选择工厂后再提交: 'Please select a equipment before submitting!',
    请选择报警策略后再提交: 'Please select an alarm strategy before submitting!',
    请填写工况异常处理后再提交: 'Please fill in abnormal working conditions and then submit!',
    该区域中存在重复配置的设备: 'There are duplicate configured equipment in the zone',
    状态突破笔数:'Number of Status Breakthroughs',
    是否已放出:'Has it been released',
    首页大屏布局: 'Home screen layout',
    默认版式: 'Default layout',
    设备列表版式: 'Equipment list layout',
    实验采集版式: 'Experiment collection format',
    操作用户: 'Operating user',
    操作路由: 'Operation routing',
    操作数据: 'Operating data',
    操作时间: 'Operating time',
    设备编号: 'Equipment ID',
    采集对象: 'Collection object',
    工况类型或编号: 'Case type or number',
    运算符: 'Operator',
    门限值: 'Threshold',
    保持状态延时: 'Hold state delay',
    误差率: 'Error rate',
    波形采集: 'Waveform acquisition',
    监测指标采集: 'Monitoring indicator collection',
    秒: 'Seconds',
    确定要删除: 'Sure to delete?',
    请选择设备后进行操作: 'Select the equipment and perform operations',
    标签: 'Label',
    类型: 'Type',
    禁用: 'Disabled',
    振动加速度: 'Vibration acceleration',
    振动速度: 'Vibration velocity',
    温度: 'Temperature',
    出口流量: 'Outlet flow',
    频率: 'Frequency',
    实际压力: 'Actual pressure',
    出口压力: 'Outlet pressure',
    电流: 'Electricity',
    电压: 'Voltage',
    扭矩: 'Torque',
    未绑定: 'Not bound',
    请选择设备: 'Please select a equipment',
    请选择类型: 'Please select a type',
    采集卡编码: 'Capture card code',
    采集卡ip: 'Capture card IP',
    采集卡类型: 'Capture card type',
    工厂名称: 'Factory name',
    传感器通道: 'Sensor channel',
    通道: 'Channel',
    采集卡配置: 'Capture card configuration',
    基本信息: 'Basic information',
    采集配置: 'Collection configuration',
    采集间隔: 'Collection interval',
    工况通道配置: 'Condition channel configuration',
    工况通道号: 'Condition channel number',
    选择测点: 'Select measuring point',
    请填写采集卡编码: 'Please fill in the capture card code',
    请选择采集卡类型: 'Please select the capture card type',
    请选择区域: 'Please select a region',
    请填写安装位置: 'Please fill in the installation location',
    请填写采集卡ip: 'Please fill in the ip address of the acquisition card',
    请完成工况通道配置的编辑后提交: 'Please finish editing the working channel configuration and submit',
    请选择采集卡类型后操作: 'Select a collection card type and perform operations !',
    采集卡id: 'Capture card id',
    ip地址: 'IP address',
    边缘电脑绑定: 'Edge computer binding',
    波形采集配置: 'Waveform acquisition configuration',
    采集方式: 'Collection method',
    波形间隔: 'Waveform interval',
    采样频率: 'Sampling frequency',
    采样时长: 'Sampling duration',
    监测指标采集配置: 'Monitoring indicator collection configuration',
    均方根间隔: 'RMS interval',
    触发条件需要同时满足不填写触发条件系统即认为触发条件满足等同于定时采集: 'The trigger conditions need to be met at the same time. If the trigger condition is not filled in, the system will consider that the trigger condition is met, which is equivalent to timing acquisition',
    通道配置: 'Channel configuration',
    通道号: 'Channel number',
    关联测点名称: 'Associated measuring point name',
    灵敏度: 'Sensitivity',
    轴向: 'Axial direction',
    轴向名称: 'Axial direction name',
    定时采集: 'Timing acquisition',
    满足触发条件的定时采集: 'Periodic collection that meets trigger conditions',
    所选通道数量小于通道配置数量: 'The number of selected channels is smaller than the configured number of channels',
    请选择采集卡类型后再添加: 'Select the card type and add it again',
    通道数量超过所选的: 'The number of channels exceeds the selected',
    请填写ip地址: 'Please fill in the IP address',
    请选择波形采集配置的波形间隔: 'Please select the waveform interval of the waveform acquisition configuration',
    请选择波形采集配置的采样频率: 'Please select the sampling frequency of the waveform acquisition configuration',
    请选择波形采集配置的采样时长: 'Please select the sampling duration of the waveform acquisition configuration',
    请选择检测指标采集配置的波形间隔: 'Please select the waveform interval of the detection index acquisition configuration',
    请选择检测指标采集配置的采样频率: 'Please select the sampling frequency of the detection index acquisition configuration',
    请完成通道配置的编辑后提交: 'Please submit after editing the channel configuration',
    通道号过大: 'Channel number too large',
    请填写灵敏度后提交: 'Please fill in the sensitivity and submit',
    切片数: 'Number of slices',
    滤波方式: 'Filtering method',
    滤波频段: 'Filter band',
    请选择滤波方式: 'Please select a filtering method',
    新增行: 'Add new line',
    选择设备: 'Select equipment',
    带通滤波: 'Band-pass filtering',
    带阻滤波: 'Band-stop filtering',
    设备选择: 'Evice selection',
    操作日期范围: 'Operation date range:',
    重置: 'Reset',
    项目: 'Project',
    状态清空时间: 'Status clear time',
    负责人: 'Person in charge',
    上一小时状态: 'Last hour status',
    是否改变状态: 'Whether to change state',
    设备稳定状态清空: 'Clear the equipment stable state',
    指标: 'Indicators',
    状态清零记录: 'Status clear record',
    状态回升记录: 'Satus recovery record',
    该设备在此时间点为关机状态请重新选择: 'The equipment is powered off at this point in time. Please select again',
    选择的时间点暂无稳定状态请重新选择: 'The selected time point is in no stable state. Please select another time point',
    请选择测点后再选择指标: 'Please select the monitoring point and then select the indicator',
    请选择日期: 'Please select a date',
    日期范围: 'Date range',
    设备参数配置: 'Equipment parameter configuration',
    专业指标: 'Professional indicators',
    通用指标: 'Common indicators',
    其他: 'Other',
    其它: 'Other',
    复制: 'Copy',
    粘贴覆盖: 'Paste overlay',
    粘贴追加: 'Paste append',
    恢复为该测点对应的阈值标准值: 'Restore to the threshold standard value corresponding to the measuring point',
    未配置标准则保留配置值: 'If no standard is configured, the configured value is retained',
    细分故障: 'Segmentation fault',
    计算方法: 'Calculation method',
    全选: 'Select all',
    复制成功: 'Successful replication!',
    请先选择需要复制的内容: 'Please first select what you want to copy',
    粘贴成功: 'Paste successfully',
    复制内容无法粘贴在该指标下: 'Copy content cannot be pasted under this indicators!',
    请先复制内容: 'Please copy the contents first!',
    删除成功: 'Successfully deleted',
    请先选择需要删除的内容: 'Please select the content you want to delete first',
    请保存后再切换: 'Please save and switch again!',
    确认执行该操作: 'Confirm to perform this operation!',
    返回: 'Return',
    部件参数: 'Component parameters',
    通用参数: 'General parameters',
    部件参数新增: 'Component parameter new',
    部件类型: 'Part type',
    配置参数: 'Configuration parameters',
    数量: 'Amount',
    参数释义: 'Parameter interpretation',
    客户: 'Client',
    诊断经理: 'Diagnostic manager',
    是否采纳: 'Whether to adopt',
    反馈是否有故障: 'Whether there is machine failure',
    是否曾发送诊断事件: 'Whether a diagnostic event was sent',
    是否更改稳定状态: 'Whether to change the stable state',
    诊断处理: 'Diagnostic processor',
    发生时间: 'Time of occurrence',
    客户经理: 'Account manager',
    稳定状态: 'Steady state',
    上一小时稳定状态: 'Steady state for the last hour',
    事件状态: 'Event status',
    是否前台显示: 'Whether to display in the foreground',
    故障模式一致性: 'Fault mode consistency',
    诊断确认: 'Confirmation of diagnosis',
    调整阈值: 'Adjust threshold',
    专家报告: 'Expert report',
    状态清零: 'Status reset',
    诊断事件: 'Diagnostic event',
    待完成: 'To be completed',
    已完成: 'Completed',
    客户反馈: 'Client feedback',
    确认提交: 'Confirm submission',
    导出详情: 'Export details',
    导出: 'Export',
    我的未完成项: 'My unfinished items',
    取消选择: 'Cancel selection',
    内部事件类型: 'Internal event type',
    警戒及以下: 'Alarm and below',
    诊断待处理: 'Diagnosis pending',
    客户支持待处理: 'Customer support pending',
    完成: 'Completed',
    诊断判断内部备注: 'Diagnosis judgment internal remarks',
    诊断判断备注: 'Remarks for diagnosis judgment',
    专家报告id: 'Expert report ID',
    添加专家报告: 'Add expert report',
    请确认是否清空当前设备稳定状态: 'Confirm whether to clear the current equipment stable state',
    客户支持: 'Customer support',
    事件进展: 'Progress of events',
    反馈一致性: 'Feedback consistency',


    自动诊断: 'Auto diagnosis',
    人工诊断: 'Manual diagnosis',
    客户支持备注: 'Customer support remark',
    附件: 'Attachment',
    否无效反馈: 'No, the feedback is invalid',
    否模糊: 'No, fuzzy',
    状态反馈一致性: 'State feedback consistency',
    认同: 'Identify with',
    不认同: 'Disagree',
    修改后认同: 'Modified approval',
    部分一致: 'Partial agreement',
    去处理: 'To handle',
    有测点数据未传回因此本条分数数据仅供参考: 'Some measuring point data has not been returned, so the score is for reference only',
    传感器测点: 'Sensor measuring point',
    健康度: 'Health degree',
    子指标名称: 'Sub-indicator name',
    子指标值: 'Sub-indicator value',
    添加现场检查或维修记录: 'Add on-site inspection or repair records',
    查看全部: 'View all',
    维修记录: 'Maintenance records',
    检查记录: 'Inspection records',
    检修时间: 'Maintenance time',
    诊断提醒: 'Diagnostic reminder',
    现场维修: 'Field maintenance',
    现场检查: 'On-site inspection',
    健康诊断分数趋势图: 'Healthy diagnosis score trend chart',
    振动指标诊断健康分数: 'Vibration indicator diagnostic Health score',
    指标趋势图: 'Indicator trend chart',
    未开机: 'Not powered on',
    智能诊断: 'Intelligent diagnosis',
    门限报警: 'Threshold alarm',
    指标监测: 'Index monitoring',
    智能诊断分数趋势: 'Smart diagnostic score trends',
    指标值对比分析: 'Comparative analysis of index values',
    时域波形图: 'Time domain diagram',
    倒频谱图: 'Cepstrum diagram',
    轴心轨迹图: 'Axis locus diagram',
    瀑布图: 'Waterfall chart',
    高频加速度: 'High frequency acceleration',
    幅值: 'Amplitude',
    倒频率: 'Cepst frequency',
    加载中: 'Loading...',
    "智能诊断-指标值及分数导出": 'Smart diagnosis - export of index values and scores',
    "实时监测-指标值导出": 'Real-time monitoring - indicator value export',
    "事件消息-事件清单导出": 'Event message - event list export',
    "app采集数据- 采集记录导出": 'App collection data - collection record export',
    "原始波形文件下载": 'Original wave file download',
    请选择测点: 'Please select a measuring point',
    请选择时间范围: 'Please select a time range',
    请选择数据类型: 'Please select a data type',
    开: 'Turn on',
    关: 'Turn off',
    全设备测点: 'All equipment measuring points',
    设备维修: 'Equipment repair',
    设备检查: 'Equipment inspection',
    更换部件: 'Parts replacement ',
    维护: 'Maintenance',
    返厂: 'Return to factory',
    登录: 'Log in',
    请输入账号:'Please enter username',
    请输入密码: 'Please enter password',
    "[安全退出]": '[Log out]',
    智能大屏: 'Dashboard',
    角色名称: 'Role name',
    工单查看: 'Worksheet view',

    小时: 'Hour',
    小时s: 'Hours',
    请输入操作记录: 'Please enter the operation record!',
    用户添加: 'User addition',
    暂无数据: 'No data',

    变频设备常用转频: 'Common frequency conversion of frequency conversion equipment',
    是否需要在该测点数据本身找转频: 'Do you need to find the conversion frequency in the data of this monitoring point',
    额定转频: 'Rated frequency conversion',
    是否需要细化频谱: 'Do you need to refine the spectrum',
    额定电源频率: 'Rated frequency of power supply',
    理论转频所在频谱: 'Theoretical frequency spectrum',
    转频换算系数: 'Frequency conversion coefficient',
    转频或部件频率上限: 'Upper limit of frequency conversion or component frequency',
    转频或部件频率下限: 'Lower limit of frequency conversion or component frequency',
    包络谱找转频滤波频段下限: 'Envelope spectrum to find the lower limit of the conversion frequency filter frequency band',
    转频数据类型: 'Frequency conversion data type',
    转频比值: 'Frequency conversion ratio',
    叶轮: 'Impeller',
    叶轮级数: 'Number of impeller stages',
    叶片数目: 'Number of blades',
    轴承: 'Bearing',
    保持架特征系数: 'Cage characteristic coefficient',
    滚动体特征系数: 'Rolling element characteristic coefficient',
    外圈特征系数: 'Outer ring characteristic coefficient',
    内圈特征系数: 'Inner ring characteristic coefficient',
    轴承型号: 'Bearing type',
    齿轮箱: 'Gearbox',
    不超过1个: 'No more than 1',
    齿轮箱种是否含有蜗轮蜗杆: 'Whether the gearbox type contains a worm gear',
    齿数: 'Number of gear teeth',
    蜗杆的头数和蜗轮的齿数: 'Number of the worm heads and number of worm gear teeth',
    柱塞泵: 'Piston pump',
    不与其他共同选择: 'Not co-opted with others',
    柱塞数目: 'Number of piston',
    柱塞泵滤波参数: 'Piston pump filter parameters',
    柱塞泵转频上限: 'Upper limit of piston pump frequency conversion ',
    柱塞泵转频下限: 'Lower limit of piston pump frequency conversion ',
    行星齿轮箱: 'Planetary gearbox',
    太阳轮齿数: 'Number of teeth of sun gear',
    一倍啮合频率: 'Double meshing frequency',
    行星轮个数: 'Number of planetary gear',
    "齿轮箱(新的指标提取方式)": 'Gearbox (new indicator extraction method)',
    齿轮齿数: 'Number of gear teeth',
    螺杆齿数: 'Number of screw teeth',
    刀头磨损: 'Blade wear',
    叶片积灰: 'Blade dust',
    异常冲击: 'Abnormal impact',
    异常特征: 'Abnormal features',
    叶轮异常: 'Vbnormal impeller',
    冲击烈度: 'Impact intensity',
    机械松动: 'Mechanical loosening',
    滑动轴承松动: 'Sliding bearing loosening',
    基础松动: 'Foundation loosening',
    配合松动: 'Fit loosening',
    机械碰摩: 'Mechanical friction',
    缺水干磨: 'Dry grinding',
    配合不良: 'Poor fit',
    零件磨损: 'Parts wear',
    非平稳故障: 'Non-stationary failure',
    气路共振: 'Air path resonance',
    滚动轴承润滑不良: 'Poor lubrication of rolling bearing',
    滑动轴承油膜涡动: 'Sliding bearing oil film whirling',
    滑动轴承油膜振荡: 'Sliding bearing oil film oscillation',
    滑动轴承烧瓦: 'Sliding bearing bush-burning ',
    滑动轴承磨损: 'Sliding bearing wear',
    滚动轴承异常: 'Rolling bearing failure',
    电磁振动: 'Electromagnetic vibration',
    螺杆啮合不良: 'Poor meshing of the screw',
    行星齿轮啮合不良: 'Poor meshing of planetary gear',
    转子不对中: 'Rotor misalignment',
    转子不平衡: 'Rotor unbalance',
    连杆异常: 'Abnormal connecting rod',
    部件碰摩: 'Part rubbing',
    滑阀碰摩: 'Spool valve rubbing',
    滑块碰摩: 'Slider rubbing',
    滑动轴承碰摩: 'Sliding bearing rubbing',
    陶瓷片脱落: 'Ceramic chip detachment',
    齿轮啮合不良: 'Poor gear meshing',

    明显发展: 'Obviously developing',
    发展: 'Developing',
    轻微发展: 'Slightly developing',
    异常特征减弱: 'Anomalous features weakened',
    有变化: 'Have changes',
    无明显变化: 'No significant changes',
    恢复健康: 'Regain health',
    短暂开机: 'Short boot',
    传输异常: 'Transmission exception',


    振动强度S1: 'Vibration intensity S1',
    振动冲击S2: 'Vibration shock S2',
    振动平衡S3: 'Vibration balance S3',
    振动极端S4: 'Vibration extremes S4',
    振动集中S5: 'Vibration concentration S5',
    振动强度S6: 'Vibration intensity S6',
    振动强度S7: 'Vibration intensity S7',
    振动强度S8: 'Vibration intensity S8',
    振动冲击S9: 'Vibration shock S9',
    振动冲击S10: 'Vibration shock S10',
    振动集中S11: 'Vibration concentration S11',
    振动冲击S12: 'Vibration shock S12',
    振动强度S13: 'Vibration intensity S13',
    振动冲击S14: 'Vibration shock S14',
    振动冲击S15: 'Vibration shock S15',
    振动冲击S16: 'Vibration shock S16',
    振动冲击S17: 'Vibration shock S17',
    振动平衡S18: 'Vibration balance S18',
    振动冲击S19: 'Vibration shock S19',
    振动强度S20: 'Vibration intensity S20',
    振动强度S21: 'Vibration intensity S21',
    振动强度S22: 'Vibration intensity S22',
    振动强度S23: 'Vibration intensity S23',
    振动强度S24: 'Vibration intensity S24',
    振动强度S26: 'Vibration intensity S26',
    振动强度S27: 'Vibration intensity S27',
    电流指标S25: 'Electric current indicators S25',
    平稳冲击烈度S28: 'Stable impact intensity S28',
    速度均方根S29: 'Velocity RMS S29',
    优化均方根S30: 'Optimize RMS S30',
    优化峰值S31: 'Optimize peak S31',
    优化峰值: 'Optimize peak',
    平稳冲击烈度S32: 'Stable impact intensity S32',
    优化峭度S33: 'Optimize kurtosis S33',
    振动强度S34: 'Vibration intensity S34',
    振动强度S35: 'Vibration intensity S35',
    振动强度S36: 'Vibration intensity S36',
    总设备数: 'Total number \n of equipment',
    设备数: 'number of equipment',
    速度: 'Speed',
    高频均方根: 'High frequency RMS',
    智能设备大屏: 'Smart screen for equipment',
    设备诊断: 'Equipment diagnosis',

    系统管理: 'System management',
    诊断趋势: 'Diagnostic trends',
    标准监测: 'Standard monitoring',
    图谱分析: 'Spectrum analysis',
    分析工具: 'Analyzing tool',
    设备事件: 'Equipment event',
    设备档案: 'Equipment profile',
    数据下载: 'Data download',


    泵输入端: 'Pump input end',
    滚动轴承润滑特征: 'Lubrication characteristics of rolling bearings',
    信号规律性特征: 'Signal regularity',
    "10～25.6KHz均方根": '10-25.6KHz RMS',
    优化峭度: 'Optimize kurtosis',
    "1～10KHz均方根": '1-10KHz RMS',
    速度均方根: 'Velocity RMS',
    滚动轴承内圈与外圈: 'Inner ring and outer ring of rolling bearing',
    "泵输入端存在异常特征，判定为滚动轴承异常，故障部位为轴承内圈和外圈，与2022/1/12事件相比，程度进一步发展；请密切关注设备状态与分数变化情况，并结合现场情况适时安排检查。": 'There is an abnormal feature in the pump input end, which is judged to be an abnormal rolling bearing. The abnormal part may be the Inner ring and outer ring of the rolling bearing. Please pay attention to the change of equipment status and score.',
    泵端面: 'Pump end face',
    非平稳故障01: 'Non-stationary failure 01',
    非平稳故障02: 'Non-stationary failure 02',
    机械碰摩01: 'Mechanical friction 01',
    机械碰摩02: 'Mechanical friction 02',
    缺水干磨01: 'Dry grinding 01',
    缺水干磨02: 'Dry grinding 02',
    配合不良01: 'Poor fit 01',
    配合不良02: 'Poor fit 02',
    零件磨损01: 'Parts wear 01',
    零件磨损02: 'Parts wear 02',
    峰峰值: 'Peak-to-peak value',
    频谱集中度: 'Spectrum concentration',
    "0～0.3KHZ均方根": "0-0.3KHZ RMS",
    全频段均方根: 'Full band root mean square',
    "0～1KHZ均方根": '0-1KHZ RMS',
    偏度因子: 'Skewness factor',
    缺水干磨主特征: 'Dry grinding features',
    振动冲击指标12: 'Vibration shock S12',
    振动冲击指标19: 'Vibration shock S19',
    振动集中指标11: 'Vibration concentration S11',
    平稳冲击烈度: 'Stable impact intensity',
    碰摩总体特征: 'Collision population characteristics',
    碰摩次阶特征: 'Collision order characteristics',
    碰摩谐波特征: 'Collisional harmonic characteristic',
    碰摩主特征2: 'Collisional friction main characteristics',
    叶片低阶特征: 'Blade lower-order feature',
    叶片中阶特征: 'Blade middle-order feature',
    不对中低阶特征: 'Misalignment lower-order feature',
    不对中中阶特征: 'Misalignment middle-order feature',
    不对中轴向特征: 'Misalignment axial feature',

    '泵输入端：滚动轴承异常；': 'Pump inlet: abnormal rolling bearing.',
    '泵输入端：部件碰摩、转子不对中；': 'Pump inlet: component rubbing、rotor misalignment.',
    '泵输入端：滚动轴承异常、转子不对中与部件碰磨': 'Pump input end: abnormal rolling bearing、rotor misalignment and part rubbing.',
    滚动轴承内圈和外圈: 'Inner ring and outer ring of rolling bearing',
    "泵端面：部件碰摩；": 'Pump end face : component rubbing.',
    "非平稳故障01，非平稳故障02，振动冲击S19。": 'Non-stationary failure 01、non-stationary failure 02、vibration shock S19。',
    "非平稳故障02。": 'Non-stationary failure 02。',


    '2号反渗透1号增压泵': 'NO.2 Reverse osmosis booster pump # 1',
    'A线3号超滤循环泵': 'A line NO.3 Ultrafiltration circulating pump',

    滚动轴承损伤: 'Rolling bearing damage',
    "非平稳故障01。": "Non-stationary failure 01.",
    "机械碰磨02。": "Mechanical friction 02.",
    电源谐波特征: 'The harmonic characteristics of a power supply',
    不平衡主特征: 'The main characteristics of an unbalanced power system',
    优化峭度指标: 'Optimizing the kurtosis index',
    平稳冲击烈度指标: 'Optimizing the stationary shock intensity index',
    振动速度均方根指标: 'Optimizing the root mean square (RMS) vibration velocity index',
    外圈特征: 'Outer ring features" or "external ring characteristics',
    内圈特征: 'Inner ring features" or "internal ring characteristics',
    滚动体特征: 'Rolling element features" or "characteristics of rolling elements',
    保持架特征: 'Cage features" or "characteristics of the cage',
    振动加速度峰值指标: "Vibration acceleration peak index",
    报告总览: 'Report Overview',
    报告时间: 'Report Time',
    事件是否处理: 'Event processing or not',
    变化趋势: 'Variation trend',
    传感器电量: 'Sensor battery level',
    "设备位号": 'Equipment Tag Number',
    "请输入设备位号": 'Please enter the equipment tag number',
    "设备功率": 'Equipment Power',
    "请输入设备功率": 'Please enter the equipment power',
    "设备ID": 'Equipment ID',
    "请输入设备ID": 'Please enter the equipment ID',
    "设备执行人": 'Equipment Operator',
    "请输入设备执行人": 'Please enter the equipment operator',
    "检测类别": 'Detection Category',
    "在线监测": 'Online Monitoring',
    "巡检": 'Inspection',
    "报告编号": 'Report ID',
    "查看报告": "View the report",
    "设备绑定": "Equipment binding",
    "报警内容": 'Alarm message',
    '发现异常特征，按照巡查计划现场查看设备状态': "Identify abnormal features and inspect equipment status on-site according to the inspection schedule",
    '发现明显异常特征，现场检查设备状态，根据现场检查结果更新维护计划，适时维护设备': 'Identify obvious abnormal features, inspect equipment status on-site, update maintenance plan based on on-site inspection results, and maintain equipment in a timely manner',
    '设备故障严重，建议停机维修': 'The equipment failure is serious, it is recommended to shut down for maintenance',
    '1K～10KHz均方根': '1K-10KHz RMS',
    '10K～25.6KHz均方根': '10K-25.6KHz RMS',
    '巡检阈值管理': 'Inspection Threshold Management',
    繁体: 'Traditional Chinese',

  },
  Chinese_ft: {
    "繁体": "繁體",
    "语言": "語言",
    "主题": "主題",
    "蓝色": "藍色",
    "白色": "白色",
    "中文": "中文",
    "英文": "英文",
    "关于": "關於",
    "合并报告": "合並報告",
    "巡检分数趋势": "巡檢分數趨勢",
    "智能诊断报告": "智能診斷報告",
    "基础巡检报告": "基礎巡檢報告",
    "全部测点": "全部測點",
    "巡检诊断": "巡檢診斷",
    "基础指标": "基礎指標",
    "最新巡检状态": "最新巡檢狀態",
    "最新巡检日期": "最新巡檢日期",
    "巡检报告数量": "巡檢報告數量",
    "巡检状态统计": "巡檢狀態統計",
    "巡检设备趋势": "巡檢設備趨勢",
    "本周巡检设备数": "本周巡檢設備數",
    "本周巡检设备健康总览": "本周巡檢設備健康總覽",
    "幅值图": "幅值圖",
    "巡检设备统计": "巡檢設備統計",
    "设备运行正常": "設備運行正常",
    "全部区域": "全部區域",
    "巡检管理": "巡檢管理",
    "巡检统计": "巡檢統計",
    "巡检报告": "巡檢報告",
    "巡检周报": "巡檢周報",
    "巡检状态": "巡檢狀態",
    "巡检日期": "巡檢日期",
    "日期": "日期",
    "巡检人": "巡檢人",
    "巡检报告类型": "巡檢報告類型",
    "导出": "導出",
    "请输入设备名称/编号/位号": "請輸入設備名稱/編號/位號",
    "基础": "基礎",
    "智能": "智能",
    "精度": "精度",
    "选中": "選中",
    "公式": "公式",
    "公式名称": "公式名稱",
    "公式内容": "公式內容",
    "数据值": "數據值",
    "变量": "變量",
    "公式模板": "公式模板",
    "测点配置": "測點配置",
    "使用公式": "使用公式",
    "未使用公式的设备": "未使用公式的設備",
    "已使用公式的设备": "已使用公式的設備",
    "数据转换公式": "數據轉換公式",
    "列表显示": "列表顯示",
    "台账显示": "臺賬顯示",
    "波形": "波形",
    "压力": "壓力",
    "工厂图": "工廠圖",
    "编辑工厂": "編輯工廠",
    "新建工厂": "新建工廠",
    "更换工厂图": "更換工廠圖",
    "左键添加标记": "左鍵添加標記",
    "左键按住可拖动": "左鍵按住可拖動",
    "右键添加标记": "右鍵添加標記",
    "上级工厂": "上級工廠",
    "请填写区域名称": "請填寫區域名稱",
    "集团不能为自身工厂": "集團不能為自身工廠",
    "请填写工厂名称": "請填寫工廠名稱",
    "累计运行": "累計運行",
    "台": "臺",
    "设备总数": "設備總數",
    "运行数": "運行數",
    "未关注": "未關註",
    "关注": "關註",
    "设备清单": "設備清單",
    "动轴承润滑不良": "動軸承潤滑不良",
    "设备生命周期管理": "設備生命周期管理",
    "AI设备卫士": "AI設備衛士",
    "智能大屏": "智能大屏",
    "设备诊断4.0": "設備診斷4.0",
    "设备管理4.0": "設備管理4.0",
    "报警管理4.0": "報警管理4.0",
    "报告管理4.0": "報告管理4.0",
    "系统配置": "系統配置",
    "诊断配置": "診斷配置",
    "知识库": "知識庫",
    "集团大屏": "集團大屏",
    "厂级大屏": "廠級大屏",
    "设备大屏": "設備大屏",
    "设备健康总览": "設備健康總覽",
    "诊断分析": "診斷分析",
    "设备列表": "設備列表",
    "报警列表": "報警列表",
    "推送规则": "推送規則",
    "专家看护配置": "專家看護配置",
    "报告管理": "報告管理",
    "角色管理": "角色管理",
    "账号管理": "賬號管理",
    "菜单管理": "菜單管理",
    "工厂配置": "工廠配置",
    "监测范围": "監測範圍",
    "监控设备数": "監控設備數",
    "监控测点数": "監控測點數",
    "运行设备数(运行率)": "運行設備數(運行率)",
    "全厂运行情况": "全廠運行情況",
    "系统持续服务运行 ": "系統持續服務運行 ",
    "全厂运行设备健康分数": "全廠運行設備健康分數 ",
    "设备健康状态统计": "設備健康狀態統計",
    "健康": "健康",
    "可用": "可用",
    "警戒": "警戒",
    "故障": "故障",
    "设备运行状态统计": "設備運行狀態統計",
    "运行": "運行",
    "停机": "停機",
    "待机": "待機",
    "设备报警数量统计": "設備報警數量統計",
    "可用报警": "可用報警",
    "警戒报警": "警戒報警",
    "故障报警": "故障報警",
    "未处理": "未處理",
    "已关闭": "已關閉",
    "已检修": "已檢修",
    "本年": "本年",
    "本月": "本月",
    "本季度": "本季度",
    "本周": "本周",
    "各厂报警数量排行": "各廠報警數量排行",
    "显示该系统为工厂上线运行的时间": "顯示該系統為工廠上線運行的時間",
    "监控设备数：用户所选组织下的监测设备数统计": "監控設備數：用戶所選組織下的監測設備數統計",
    "监控测点数：用户所选组织下的监测测点数统计": "監控測點數：用戶所選組織下的監測測點數統計",
    "运行设备数：用户所选组织下的监测设备中运行设备数统计": "運行設備數：用戶所選組織下的監測設備中運行設備數統計",
    "运行率：用户所选组织下的监测设备中运行设备数/监测设备总数": "運行率：用戶所選組織下的監測設備中運行設備數/監測設備總數",
    "设备报警趋势": "設備報警趨勢",
    "设备报警记录": "設備報警記錄",
    "报警时间": "報警時間",
    "区域清单": "區域清單",
    "显示单位": "顯示單位",
    "监测设备": "監測設備",
    "监测测点": "監測測點",
    "运行设备": "運行設備",
    "报警设备": "報警設備",
    "未处理报警": "未處理報警",
    "运行率": "運行率",
    "请确认区域（车间）名称": "請確認區域（車間）名稱",
    "所属行业": "所屬行業",
    "请选择所属行业": "請選擇所屬行業",
    "工厂地址": "工廠地址",
    "请输入工厂地址": "請輸入工廠地址",
    "请输入工厂名称": "請輸入工廠名稱",
    "地图标记": "地圖標記",
    "当前运行状态": "當前運行狀態",
    "设备厂家": "設備廠家",
    "设备状态占比": "設備狀態占比",
    "运行占比": "運行占比",
    "运行时间": "運行時間",
    "健康占比": "健康占比",
    "健康时间": "健康時間",
    "可用占比": "可用占比",
    "可用时间": "可用時間",
    "警戒占比": "警戒占比",
    "警戒时间": "警戒時間",
    "故障占比": "故障占比",
    "故障时间": "故障時間",
    "累计运行时间": "累計運行時間",
    "分数趋势": "分數趨勢",
    "报警事件": "報警事件",
    "检修记录": "檢修記錄",
    "诊断报醒": "診斷報醒",
    "已处理": "已處理",
    "请选择设备区域": "請選擇設備區域",
    "请选择报警类型": "請選擇報警類型",
    "请选择严重程度": "請選擇嚴重程度",
    "关闭报警": "關閉報警",
    "下载报警": "下載報警",
    "请选择报警": "請選擇報警",
    "请选择未处理的报警": "請選擇未處理的報警",
    "请填写关闭原因": "請填寫關閉原因",
    "关闭成功": "關閉成功",
    "请耐心等待，完成加载后，点击下载即可下载文件，请勿反复点击下载或关闭本网站": "請耐心等待，完成加載後，點擊下載即可下載文件，請勿反復點擊下載或關閉本網站",
    "请输入设备名称搜索": "請輸入設備名稱搜索",
    "请输入测点名称搜索": "請輸入測點名稱搜索",
    "设备健康状态": "設備健康狀態",
    "综合状态": "綜合狀態",
    "设备基本信息": "設備基本信息",
    "设备位置": "設備位置",
    "收起": "收起",
    "展开": "展開",
    "近两月": "近兩月",
    "设备健康事件时间轴": "設備健康事件時間軸",
    "健康指标诊断分数趋势图": "健康指標診斷分數趨勢圖",
    "振动指标诊断分数趋势图": "振動指標診斷分數趨勢圖",
    '是否显示': '是否顯示',
    "显示": "顯示",
    "隐藏": "隱藏",
    "开关机线": "開關機線",
    "运行时间趋势": "運行時間趨勢",
    "指标监测趋势": "指標監測趨勢",
    "指标值": "指標值",
    "检修事件": "檢修事件",
    "添加检修记录": "添加檢修記錄",
    "批量关闭报警": "批量關閉報警",
    "排序": "排序",
    "事件类型": "事件類型",
    "诊断报警": "診斷報警",
    "请选择健康状态": "請選擇健康狀態",
    "运行状态": "運行狀態",
    "请选择运行状态": "請選擇運行狀態",
    "请输入设备名称/编号": "請輸入設備名稱/編號",
    "新建设备": "新建設備",
    "测点列表": "測點列表",
    "设备序号": "設備序號",
    "是否实验台": "是否實驗臺",
    "请选择是否为试验台": "請選擇是否為試驗臺",
    "所属工厂": "所屬工廠",
    "报警记录": "報警記錄",
    "健康总览": "健康總覽",
    "测点位置": "測點位置",
    "请输入测点位置": "請輸入測點位置",
    "新建测点": "新建測點",
    "编辑设备": "編輯設備",
    "设备照片": "設備照片",
    "故障信息": "故障信息",
    "故障详情": "故障詳情",
    "检修照片": "檢修照片",
    "诊断设备": "診斷設備",
    "建议及措施": "建議及措施",
    "编辑测点": "編輯測點",
    "请输入传感器SN": "請輸入傳感器SN",
    "请输入数采器编码": "請輸入數采器編碼",
    "请输入安装位置": "請輸入安裝位置",
    "转频提取": "轉頻提取",
    "请选择转频提取测点": "請選擇轉頻提取測點",
    "请选择设备类型": "請選擇設備類型",
    "请选择功率": "請選擇功率",
    "请输入编号": "請輸入編號",
    "请输入安装坐标": "請輸入安裝坐標",
    "请输入轴名称": "請輸入軸名稱",
    "测点照片": "測點照片",
    "请输入备注": "請輸入備註",
    "编号": "編號",
    "水平径向": "水平徑向",
    "竖直径向": "豎直徑向",
    "传感器编号": "傳感器編號",
    "轴名称": "軸名稱",
    "测点ID": "測點ID",
    "是否试验台": "是否試驗臺",
    "总貌图": "總貌圖",
    "左键按住可拖动，右键添加标记": "左鍵按住可拖動，右鍵添加標記",
    "关闭原因": "關閉原因",
    "旋转": "旋轉",
    "更换3D图": "更換3D圖",
    "更换2D图": "更換2D圖",
    "选择设备区域": "選擇設備區域",
    "选择严重程度": "選擇嚴重程度",
    "请输入关键词搜索": "請輸入關鍵詞搜索",
    "检修详情": "檢修詳情",
    "开始时间": "開始時間",
    "结束时间": "結束時間",
    "检修人员": "檢修人員",
    "现场设备状态": "現場設備狀態",
    "故障描述": "故障描述",
    "健康设备": "健康設備",
    "可用设备": "可用設備",
    "警戒设备": "警戒設備",
    "故障设备": "故障設備",
    "分析周期": "分析周期",
    "故障模式统计(本年)": "故障模式統計(本年)",
    "本周检修/检查": "本周檢修/檢查",
    "本月检修/检查": "本月檢修/檢查",
    "周报转发：复制链接转发，用户可在电脑端或手机端查看": "周報轉發：復制鏈接轉發，用戶可在電腦端或手機端查看",
    "手机端链接": "手機端鏈接",
    "参数配置": "參數配置",
    "操作日志": "操作日誌",
    "登录日志": "登錄日誌",
    "数据变更日志": "數據變更日誌",
    "数采器列表": "數采器列表",
    "传感器监测": "傳感器監測",
    "采集单元监测": "采集單元監測",
    "服务监测": "服務監測",
    "系统监测报警": "系統監測報警",
    "工况对接配置": "工況對接配置",
    "周报配置": "周報配置",
    "智能诊断报警配置": "智能診斷報警配置",
    "标准监测报警配置": "標準監測報警配置",
    "非标设备管理": "非標設備管理",
    "设备首页": "設備首頁",
    "三级菜单测试第二级": "三級菜單測試第二級",
    "三级菜单测试第三级": "三級菜單測試第三級",
    "设备事件报警": "設備事件報警",
    "测试三级2": "測試三級2",
    "故障标准库": "故障標準庫",
    "3D模型库": "3D模型庫",
    "开关机配置": "開關機配置",
    "采集器列表": "采集器列表",
    "请输入角色名称": "請輸入角色名稱",
    "请选择菜单": "請選擇菜單",
    "请选择工厂权限": "請選擇工廠權限",
    "工厂权限": "工廠權限",
    "确定删除此条数据么": "確定刪除此條數據麽",
    "昵称/用户名/手机号": "昵稱/用戶名/手機號",
    "请选择所属工厂": "請選擇所屬工廠",
    "配置": "配置",
    "配置权限": "配置權限",
    "输入用户名": "輸入用戶名",
    "输入昵称": "輸入昵稱",
    "不修改密码无需输入": "不修改密碼無需輸入",
    "菜单名称": "菜單名稱",
    "菜单路由": "菜單路由",
    "菜单Code": "菜單Code",
    "上级菜单": "上級菜單",
    "菜单类型": "菜單類型",
    "按钮": "按鈕",
    "链接": "鏈接",
    "路由地址": "路由地址",
    "请输入路由地址": "請輸入路由地址",
    "菜单排序": "菜單排序",
    "菜单状态": "菜單狀態",
    "一级菜单": "壹級菜單",
    "定位": "定位",
    "集团": "集團",
    "请选择集团": "請選擇集團",
    "故障释义": "故障釋義",
    "一级分类": "壹級分類",
    "请输入一级分类": "請輸入壹級分類",
    "二级分类": "二級分類",
    "请输入二级分类": "請輸入二級分類",
    "三级分类": "三級分類",
    "请输入三级分类": "請輸入三級分類",
    "缩写": "縮寫",
    "请输入缩写": "請輸入縮寫",
    "模型图": "模型圖",
    "输入区域或设备名称筛选": "輸入區域或設備名稱篩選",
    "未选择设备或没有配置测点": "未選擇設備或沒有配置測點",
    "粘贴": "粘貼",
    "确定删除所选数据么": "確定刪除所選數據麽",
    "请选择复制的内容": "請選擇復制的內容",
    "不允许粘贴": "不允許粘貼",
    "没有复制的内容": "沒有復制的內容",
    "请选择内容": "請選擇內容",
    "振动参数": "振動參數",
    "请选择项目": "請選擇項目",
    "诊断工单(待完成)": "診斷工單(待完成)",
    "诊断工单(已完成)": "診斷工單(已完成)",
    "确认删除": "確認刪除",
    "请填写诊断判断备注": "請填寫診斷判斷備註",
    "保存任务处理": "保存任務處理",
    "请输入切片数": "請輸入切片數",
    "请选择工厂后提交": "請選擇工廠後提交",
    "周报月报配置": "周報月報配置",
    "报告生成策略": "報告生成策略",
    "是否生成报告": "是否生成報告",
    "每月第": "每月第",
    "每周第": "每周第",
    "天生成月报": "天生成月報",
    "天生成周报": "天生成周報",
    "星期一": "星期壹",
    "星期二": "星期二",
    "星期三": "星期三",
    "星期四": "星期四",
    "星期五": "星期五",
    "星期六": "星期六",
    "星期日": "星期日",
    "第": "第",
    "小时生成报告": "小時生成報告",
    "故障信息(请勾选此次维修的故障项)": "故障信息(請勾選此次維修的故障項)",
    "维修详情": "維修詳情",
    "故障信息(请勾选此次关闭的故障项)": "故障信息(請勾選此次關閉的故障項)",
    "检修图片": "檢修圖片",
    "请选择开始时间": "請選擇開始時間",
    "请选择结束时间": "請選擇結束時間",
    "请填写检修人员": "請填寫檢修人員",
    "请选择现场设备状态": "請選擇現場設備狀態",
    "请填写故障原因": "請填寫故障原因",
    "请填写检修内容": "請填寫檢修內容",
    "新增成功": "新增成功",
    "请选择关闭的故障项": "請選擇關閉的故障項",
    "低频加速度X(m/s2)": "低頻加速度X(m/s2)",
    "低频加速度Y(m/s2)": "低頻加速度Y(m/s2)",
    "低频加速度Z(m/s2)": "低頻加速度Z(m/s2)",
    "温度(­°C)": "溫度(­°C)",
    "速度X(mm/s)": "速度X(mm/s)",
    "速度Y(mm/s)": "速度Y(mm/s)",
    "速度Z(mm/s)": "速度Z(mm/s)",
    "高频加速度(m/s2)": "高頻加速度(m/s2)",
    "低频加速度X": "低頻加速度X",
    "低频加速度Y": "低頻加速度Y",
    "低频加速度Z": "低頻加速度Z",
    "速度X": "速度X",
    "速度Z": "速度Z",
    "健康设备数": "健康設備數",
    "可用设备数": "可用設備數",
    "警戒设备数": "警戒設備數",
    "故障设备数": "故障設備數",
    "停机设备数": "停機設備數",
    "待机设备数": "待機設備數",
    "运行设备数": "運行設備數",
    "高频加速度(长)": "高頻加速度(長)",
    "速度Y": "速度Y",
    "趋势图": "趨勢圖",
    "时域图": "時域圖",
    "现场情况": "現場情況",
    "有效值": "有效值",
    "倍频": "倍頻",
    "边频": "邊頻",
    "清空标注": "清空標註",
    "值": "值",
    "暂无下载文件": "暫無下載文件",
    "频谱": "頻譜",
    "选择范围": "選擇範圍",
    "包络解调": "包絡解調",
    "采样时间": "采樣時間",
    "振动指标-均方根": "振動指標-均方根",
    "振动指标-0~0.3KHz均方根": "振動指標-0~0.3KHz均方根",
    "振动指标-0~1KHz均方根": "振動指標-0~1KHz均方根",
    "振动指标-1K~10KHz均方根": "振動指標-1K~10KHz均方根",
    "振动指标-10K~25.6KHz均方根": "振動指標-10K~25.6KHz均方根",
    "振动指标-1K~25.6KHz均方根": "振動指標-1K~25.6KHz均方根",
    "振动指标-0~25.6KHz均方根": "振動指標-0~25.6KHz均方根",
    "振动指标-优化峭度01": "振動指標-優化峭度01",
    "振动指标-平稳冲击烈度": "振動指標-平穩沖擊烈度",
    "振动指标-线性峭度02": "振動指標-線性峭度02",
    "振动指标-峭度因子": "振動指標-峭度因子",
    "振动指标-峰峰值": "振動指標-峰峰值",
    "振动指标-优化峰值": "振動指標-優化峰值",
    "振动指标-优化偏度": "振動指標-優化偏度",
    "振动指标-速度均方根": "振動指標-速度均方根",
    "振动指标-频率集中度": "振動指標-頻率集中度",
    "振动指标-0.3~1KHz均方根": "振動指標-0.3~1KHz均方根",
    "振动指标-1K~3KHz均方根": "振動指標-1K~3KHz均方根",
    "振动指标-3K~6KHz均方根": "振動指標-3K~6KHz均方根",
    "振动指标-6K~12KHz均方根": "振動指標-6K~12KHz均方根",
    "振动指标-12000~25600Hz均方根": "振動指標-12000~25600Hz均方根",
    "振动指标-6K~10KHz均方根": "振動指標-6K~10KHz均方根",
    "振动指标-优化均方根": "振動指標-優化均方根",
    "振动指标-偏度因子": "振動指標-偏度因子",
    "振动指标-裕度因子": "振動指標-裕度因子",
    "振动指标-峰值指标": "振動指標-峰值指標",
    "振动指标-包络信息熵": "振動指標-包絡信息熵",
    "振动指标-包络幅值峭度": "振動指標-包絡幅值峭度",
    "振动指标-脉冲因子": "振動指標-脈沖因子",
    "振动指标-波形因子": "振動指標-波形因子",
    "振动指标-均值频率": "振動指標-均值頻率",
    "振动指标-主频带位置": "振動指標-主頻帶位置",
    "振动指标-时域信息熵": "振動指標-時域信息熵",
    "振动指标-频域信息熵": "振動指標-頻域信息熵",
    "振动指标-电流指标": "振動指標-電流指標",
    "趋势波形图": "趨勢波形圖",
    "多时域频谱": "多時域頻譜",
    "诊断分数趋势": "診斷分數趨勢",
    "倒频谱": "倒頻譜",
    "加速度均方根": "加速度均方根",
    "幅值-m/s²": "幅值-m/s²",
    "频率-Hz": "頻率-Hz",
    "振动指标-Trms": "振動指標-Trms",
    "振动指标-Trms_300": "振動指標-Trms_300",
    "振动指标-Trms_1000": "振動指標-Trms_1000",
    "振动指标-Trms_1000_10000": "振動指標-Trms_1000_10000",
    "振动指标-Trms_10000_25600": "振動指標-Trms_10000_25600",
    "振动指标-Trms_1000_25600": "振動指標-Trms_1000_25600",
    "振动指标-TLinKurt": "振動指標-TLinKurt",
    "振动指标-TImpactIntensity": "振動指標-TImpactIntensity",
    "振动指标-Tlin_kurt": "振動指標-Tlin_kurt",
    "振动指标-Tkurt": "振動指標-Tkurt",
    "振动指标-Tff": "振動指標-Tff",
    "振动指标-TAccelerationPeak": "振動指標-TAccelerationPeak",
    "振动指标-Tlin_bias": "振動指標-Tlin_bias",
    "振动指标-TVelocityRMS": "振動指標-TVelocityRMS",
    "振动指标-Tcon": "振動指標-Tcon",
    "振动指标-Trms_300_1000": "振動指標-Trms_300_1000",
    "振动指标-Trms_1000_3000": "振動指標-Trms_1000_3000",
    "振动指标-Trms_3000_6000": "振動指標-Trms_3000_6000",
    "振动指标-Trms_6000_12000": "振動指標-Trms_6000_12000",
    "振动指标-Trms_12000_25600": "振動指標-Trms_12000_25600",
    "振动指标-Trms_6000_10000": "振動指標-Trms_6000_10000",
    "振动指标-TAccelerationRMS": "振動指標-TAccelerationRMS",
    "振动指标-Tbias": "振動指標-Tbias",
    "振动指标-Tmargin": "振動指標-Tmargin",
    "振动指标-Tpp": "振動指標-Tpp",
    "振动指标-Tent_e": "振動指標-Tent_e",
    "振动指标-Tenv_kurt": "振動指標-Tenv_kurt",
    "振动指标-Tpulse": "振動指標-Tpulse",
    "振动指标-Twave": "振動指標-Twave",
    "振动指标-TF9": "振動指標-TF9",
    "振动指标-Tmainf": "振動指標-Tmainf",
    "振动指标-Tent_t": "振動指標-Tent_t",
    "振动指标-Tent_f": "振動指標-Tent_f",
    "振动指标-Tcurrent": "振動指標-振動指標-Tcurrent",





    "电机驱动端": "電機驅動端",
    "一轴输入端": "壹軸輸入端",
    "一轴输出端": "壹軸輸出端",
    "二轴输入端": "二軸輸入端",
    "二轴输出端": "二軸輸出端",
    "三轴输出端": "三軸輸出端",
    "滚筒轴承": "滾筒軸承",
    "左侧滚筒轴承": "左側滾筒軸承",
    "左侧电机驱动端": "左側電機驅動端",
    "三轴输入端": "三軸輸入端",
    "四轴左侧输出端": "四軸左側輸出端",
    "四轴右侧输出端": "四軸右側輸出端",
    "右侧滚筒轴承": "右側滾筒軸承",
    "一轴左侧输入端": "壹軸左側輸入端",
    "一轴右侧输入端": "壹軸右側輸入端",
    "右侧电机驱动端": "右側電機驅動端",
    "四轴输出端": "四軸輸出端",
    "查看详情": "查看詳情",
    "返回机房": "返回機房",
    "暂无事件": "暫無事件",
    "条": "條",
    "查看更多": "查看更多",
    "点击查看详情": "點擊查看詳情",
    "机房": "機房",
    "健康指标": "健康指標",
    "振动指标": "振動指標",
    "分": "分",
    "系统持续服务运行": "系統持續服務運行",
    "区域健康评分": "區域健康評分",
    "针对运行中的设备, 状态得分的加权平均数计算为全厂健康分数, 健康设备记100分, 可用设备记80分, 警戒设备记60分, 故障设备记30分": "針對全部設備, 狀態得分的加權平均數計算為全廠健康分數, 健康設備記100分, 可用設備記80分, 警戒設備記60分, 故障設備記30分",
    "传感器安装位置": "傳感器安裝位置",
    "转速": "轉速",
    "时间": "時間",
    "操作": "操作",
    "下载": "下載",
    "条数据": "條數據",
    "请耐心等待完成加载后点击确认即可下载文件请勿反复点击下载或关闭本网站": "請耐心等待，完成加載後，點擊確認即可下載文件，請勿反復點擊下載或關閉本網站。",
    "共": "共",
    "近一天": "近壹天",
    "近一周": "近壹周",
    "近一月": "近壹月",
    "自定义": "自定義",
    "筛选": "篩選",
    "自动刷新": "自動刷新",
    "关闭": "關閉",
    "开启": "開啟",
    "工况数据": "工況數據",
    "工况名称": "工況名稱",
    "工况值": "工況值",
    "工况信息图表": "工況信息圖表",
    "全部设备": "全部設備",
    "搜索": "搜索",
    "搜索设备信息": "搜索設備信息",
    "设备名称": "設備名稱",
    "设备区域": "設備區域",
    "安装位置": "安裝位置",
    "当前状态": "當前狀態",
    "健康状态描述": "健康狀態描述",
    "状态": "狀態",
    "分数等级": "分數等級",
    "建议客户的行为": "建議客戶的行為",
    "建议使用时间": "建議使用時間",
    "可用上": "可用上",
    "可用下": "可用下",
    "警戒上": "警戒上",
    "警戒中": "警戒中",
    "警戒下": "警戒下",
    "故障上": "故障上",
    "故障下": "故障下",
    "无": "無",
    "无需操作": "無需操作",
    "可持续使用": "可持續使用",
    "一级可用": "壹級可用",
    "二级可用": "二級可用",
    "一级警戒": "壹級警戒",
    "二级警戒": "二級警戒",
    "发现异常特征关注AI设备卫士中设备分数变化趋势": "發現異常特征，關註AI設備衛士中設備分數變化趨勢",
    "发现异常特征按照巡查计划现场查看设备状态": "發現異常特征，按照巡查計劃現場查看設備狀態",
    "天07内查看": "0-7天內查看",
    "具体时间因设备和故障类型而异": "具體時間因設備和故障類型而異",
    "发现明显异常特征现场检查设备状态根据现场检查结果更新维护计划": "發現明顯異常特征，現場檢查設備狀態，根據現場檢查結果更新維護計劃",
    "天03内检查天170内维护": "0-3天內檢查，1-70天內維護",
    "发现明显异常特征现场检查设备状态制定维护计划适时维护设备": "發現明顯異常特征，現場檢查設備狀態，制定維護計劃，適時維護設備",
    "天03内检查天130内维护": "0-3天內檢查，1-30天內維護",
    "停止运行机器进行维护": "停止運行機器，進行維護",
    "尽快停机": "盡快停機",
    "健康状态": "健康狀態",
    "运行中": "運行中",
    "已停止": "已停止",
    "查看": "查看",
    "诊断报告": "診斷報告",
    "检修报告": "檢修報告",
    "设备详情": "設備詳情",
    "设备型号": "設備型號",
    "设备品牌": "設備品牌",
    "添加日期": "添加日期",
    "设备描述": "設備描述",
    "个人报告": "個人報告",
    "周报月报": "周報月報",
    "账户管理": "賬戶管理",
    "报警管理": "報警管理",
    "状态监测报警": "狀態監測報警",
    "智能诊断报警": "智能診斷報警",
    "智能诊断模型配置": "智能診斷模型配置",
    "工厂设备管理": "工廠設備管理",
    "设备管理": "設備管理",
    "测点管理": "測點管理",
    "系统日志": "系統日誌",
    "日志管理": "日誌管理",
    "访问日志": "訪問日誌",
    "工况触发采集配置": "工況觸發采集配置",
    "工况数据管理": "工況數據管理",
    "工况采集卡管理": "工況采集卡管理",
    "有线采集卡管理": "有線采集卡管理",
    "诊断管理": "診斷管理",
    "模型配置": "模型配置",
    "诊断工单管理": "診斷工單管理",
    "稳定状态清空": "穩定狀態清空",
    "数据清洗配置": "數據清洗配置",
    "搜索设备信息报告内容等": "搜索設備信息、報告內容等",
    "选择日期": "選擇日期",
    "设备": "設備",
    "诊断描述": "診斷描述",
    "严重程度": "嚴重程度",
    "最近更新": "最近更新",
    "轻微": "輕微",
    "中度": "中度",
    "严重": "嚴重",
    "诊断详情": "診斷詳情",
    "健康事件": "健康事件",
    "可用事件": "可用事件",
    "警戒事件": "警戒事件",
    "故障事件": "故障事件",
    "幅值谱图": "幅值譜圖",
    "包络谱图": "包絡譜圖",
    "故障原因": "故障原因",
    "备注": "備註",
    "报告状态": "報告狀態",
    "数据源": "數據源",
    "提交日期": "提交日期",
    "已诊断": "已診斷",
    "诊断中": "診斷中",
    "个人申请": "個人申請",
    "巡检记录": "巡檢記錄",
    "异常数据报警": "異常數據報警",
    "个人报告信息": "個人報告信息",
    "诊断中请耐心等待": "診斷中，請耐心等待",
    "当前设备问题严重程度为重度请及时进行检查与维修": "當前設備問題嚴重程度為重度，請及時進行檢查與維修",
    "当前设备问题严重程度为中度请密切关注请结合现场情况适时检查": "當前設備問題嚴重程度為中度，請密切關註，請結合現場情況適時檢查。",
    "当前设备问题严重程度为轻度请关注": "當前設備問題嚴重程度為輕度，請關註。",
    "诊断结论": "診斷結論",
    "报告内容": "報告內容",
    "现场照片": "現場照片",
    "未上传": "未上傳",
    "设备信息": "設備信息",
    "检修日期": "檢修日期",
    "检修内容": "檢修內容",
    "故障类型": "故障類型",
    "检修人": "檢修人",
    "提交时间": "提交時間",
    "检修报告详情": "檢修報告詳情",
    "检修结果": "檢修結果",
    "综合健康状态": "綜合健康狀態",
    "当前设备分数": "當前設備狀態",
    "现场设备状态判断": "現場設備狀態判斷",
    "现场反馈详情": "現場反饋詳情",
    "故障模式": "故障模式",
    "一致性": "壹致性",
    "一致": "壹致",
    "不确定": "不確定",
    "不一致": "不壹致",
    "操作记录": "操作記錄",
    "检修信息": "檢修信息",
    "报告标题": "報告標題",
    "报告周期": "報告周期",
    "报告类型": "報告類型",
    "周": "周",
    "月报": "月報",
    "周报": "周報",
    "报告统计时间": "報告統計時間",
    "报告日期": "報告日期",
    "设备详情清单": "設備詳情清單",
    "取消": "取消",
    "保存": "保存",
    "设备状态": "設備狀態",
    "状态变化": "狀態變化",
    "诊断结果": "診斷結果",
    "未知因素": "未知因素",
    "本周检修检查": "本周檢修/檢查",
    "pc端链接": "pc端鏈接",
    "移动端链接": "移動端鏈接",
    "周报转发分别复制链接转发用户可在电脑端或手机端查看": "周報轉發：分別復制鏈接轉發，用戶可在電腦端或手機端查看",
    "本周设备健康总览": "本周設備健康總覽",
    "本周设备事件提醒总览": "本周設備事件提醒總覽",
    "故障模式统计本年": "故障模式統計（本年）",
    "有线采集管理": "有線采集管理",
    "成功": "成功",
    "失败": "失敗",
    "添加账户": "添加賬戶",
    "昵称": "昵稱",
    "用户名": "用戶名",
    "角色": "角色",
    "手机号": "手機號",
    "是否启用": "是否啟用",
    "权限标签": "權限標簽",
    "关键词": "關鍵詞",
    "昵称用户名手机号": "昵稱/用戶名/手機號",
    "全部": "全部",
    "是": "是",
    "否": "否",
    "编辑": "編輯",
    "停用": "停用",
    "启用": "啟用",
    "重置密码": "重置密碼",
    "修改密码": "修改密碼",
    "修改账户": "修改賬戶",
    "请输入用户名": "請輸入用戶名",
    "请输入昵称": "請輸入昵稱",
    "密码": "密碼",
    "密码至少8位": "密碼至少8位",
    "随机生成": "隨機生成",
    "请选择角色": "請選擇角色",
    "工厂": "工廠",
    "请输入手机号": "請輸入手機號",
    "请选择工厂": "請選擇工廠",
    "请选择": "請選擇",
    "确定": "確定",
    "重置该用户密码": "重置該用戶密碼",
    "新密码": "新密碼",
    "旧密码": "舊密碼",
    "角色名": "角色名",
    "查询": "查詢",
    "菜单": "菜單",
    "删除": "刪除",
    "新增": "新增",
    "确认删除该角色": "確認刪除該角色!",
    "保存成功": "保存成功",
    "保存失败": "保存失敗",
    "编辑成功": "編輯成功",
    "操作成功": "操作成功",
    "区域": "區域",
    "设备id": "設備id",
    "设备类型": "設備類型",
    "厂家": "廠家",
    "型号": "型號",
    "机器SN号": "機器SN號",
    "序号": "序號",
    "是否是试验台": "是否是試驗臺",
    "传感器位置": "傳感器位置",
    "设备类型缩写": "設備類型縮寫",
    "生产厂家": "生產廠家",
    "设备SN号": "設備SN號",
    "试验台": "試驗臺",
    "版本": "版本",
    "旗舰版": "旗艦版",
    "商业版": "商業版",
    "设备图片": "設備圖片",
    "上传": "上傳",
    "提交": "提交",
    "请输入": "請輸入",
    "操作失败": "操作失敗",
    "文件上传失败请联系管理员": "文件上傳失敗,請聯系管理員",
    "传感器SN": "傳感器SN",
    "数采器编码": "數采器編碼",
    "是否有网关": "是否有網關",
    "测点id": "測點id",
    "当前设备": "當前設備",
    "转频提取测点": "轉頻提取測點",
    "轴参数": "軸參數",
    "DT编号": "DT編號",
    "安装坐标": "安裝坐標",
    "名称": "名稱",
    "报警类型": "報警類型",
    "高频": "高頻",
    "低频": "低頻",
    "路径": "路徑",
    "更新时间": "更新時間",
    "当前值": "當前值",
    "特性": "特性",
    "所属设备": "所屬設備",
    "功率": "功率",
    "三轴参数": "三軸參數",
    "数据类型": "數據類型",
    "默认展示数据类型": "默認展示數據類型",
    "保存路径": "保存路徑",
    "上次更新": "上次更新",
    "添加": "添加",
    "生成三轴参数": "生成三軸參數",
    "选择": "選擇",
    "搜索测点信息": "搜索測點信息",
    "是否推送": "是否推送",
    "推送人": "推送人",
    "清空": "清空",
    "说明": "說明",
    "测点": "測點",
    "指标名称": "指標名稱",
    "单位与描述": "單位與描述",
    "一级门限可用": "壹級門限可用",
    "报警间隔天": "報警間隔天",
    "二级门限警戒": "二級門限警戒",
    "三级门限故障": "三級門限故障",
    "不推送": "不推送",
    "确认": "確認",
    "同步标准": "同步標準",
    "基于国际国家或行业内既定标准实现对设备运行状态进行监测同时可纵向参考设备历史运行数据横向比较同类设备运行数据确定各报警等级的阈值": "基於國際、國家或行業內既定標準，實現對設備運行狀態進行監測。同時，可縱向參考設備歷史運行數據，橫向比較同類設備運行數據，確定各報警等級的閾值。",
    "但依据标准设定的绝对合理的阈值很难获取设定过高的报警阈值会造成设备故障": "但依據標準設定的絕對合理的閾值很難獲取，設定過高的報警閾值會造成設備故障",
    "漏报": "漏報",
    "的风险而阈值过低又会来带大量的": "的風險，而閾值過低又會來帶大量的",
    "误报警": "誤報警",
    "给现场处理造成极大的压力此外仅按照标准规定中的几种指标设定的阈值报警所能发现的故障模式有限设置和修改阈值也面临必需手动调整与工作量大等问题": "，給現場處理造成極大的壓力；此外，僅按照標準規定中的幾種指標設定的閾值報警所能發現的故障模式有限。設置和修改閾值也面臨必需手動調整與工作量大等問題。",
    "根据各类国际国家行业标准根据对目前所有设备类型参照相应标准做如下统计": "根據各類國際、國家、行業標準，根據對目前所有設備類型，參照相應標準，做如下統計：",
    "采用标准": "采用標準",
    "电机类": "電機類",
    "泵类": "泵類",
    "往复类": "往復類",
    "风机类": "風機類",
    "齿轮类": "齒輪類",
    "螺杆式": "螺桿式",
    "汽轮机": "汽輪機",
    "通用设备": "通用設備",
    "报警策略": "報警策略",
    "工况异常处理": "工況異常處理",
    "是否专家看护": "是否專家看護",
    "是否专家认证": "是否專家認證",
    "分指标报警": "分指標報警",
    "按设备整体状态": "按設備整體狀態",
    "单点即刻报警": "單點即刻報警",
    "短期重复出现报警": "短期重復出現報警",
    "智能诊断报警策略组合": "智能診斷報警策略組合",
    "一旦监测到分数异常即刻报警": "壹旦監測到分數異常，即刻報警",
    "统计短期内重复出现同类型异常报警去除工况突变数据采集等异常值误报": "統計短期內重復出現同類型異常報警，去除工況突變、數據采集等異常值誤報",
    "每个指标发生分数恶化都单独发送报警": "每個指標發生分數惡化，都單獨發送報警",
    "适合处于非健康状态或指标磨合期的设备需要故障模式报警": "適合處於非健康狀態，或指標磨合期的設備，需要故障模式報警",
    "适合运行较稳定需要故障模式报警": "適合運行較穩定，需要故障模式報警",
    "仅当设备整体状态恶化时发送报警": "僅當設備整體狀態惡化時，發送報警",
    "用于对整体设备状态监测非健康设备报警时效性要求高": "用於對整體設備狀態監測，非健康設備報警時效性要求高",
    "用于对整体设备状态监测设备运行较稳定趋势性变化突发异常概率低": "用於對整體設備狀態監測，設備運行較穩定，趨勢性變化突發異常概率低",
    "笔内出现": "筆內，出現",
    "次": "次",
    "开关机影响时间范围": "開關機影響時間範圍",
    "分钟": "分鐘",
    "范围": "範圍",
    "状态回升灵敏度": "狀態回升靈敏度",
    "距最近开机": "距最近開機",
    "笔数据判断状态向前": "筆數據判斷狀態，向前",
    "笔数据判断状态": "筆數據判斷狀態。",
    "请选择工厂后再提交": "請選擇工廠後再提交!",
    "请选择区域后再提交": "請選擇區域後再提交!",
    "请选择设备后再提交": "請選擇設備後再提交!",
    "请选择报警策略后再提交": "請選擇報警策略後再提交!",
    "请填写工况异常处理后再提交": "請填寫工況異常處理後再提交!",
    "该区域中存在重复配置的设备": "該區域中存在重復配置的設備",
    "首页大屏布局": "首頁大屏布局",
    "默认版式": "默認版式",
    "设备列表版式": "設備列表版式",
    "实验采集版式": "實驗采集版式",
    "操作用户": "操作用戶",
    "操作路由": "操作路由",
    "操作数据": "操作數據",
    "操作时间": "操作時間",
    "设备编号": "設備編號",
    "采集对象": "采集對象",
    "工况类型或编号": "工況類型或編號",
    "运算符": "運算符",
    "门限值": "門限值",
    "保持状态延时": "保持狀態延時",
    "误差率": "誤差率",
    "波形采集": "波形采集",
    "监测指标采集": "監測指標采集",
    "秒": "秒",
    "确定要删除": "確定要刪除？",
    "请选择设备后进行操作": "請選擇設備後進行操作",
    "标签": "標簽",
    "类型": "類型",
    "禁用": "禁用",
    "振动加速度": "振動加速度",
    "振动速度": "振動速度",
    "温度": "溫度",
    "出口流量": "出口流量",
    "频率": "頻率",
    "实际压力": "實際壓力",
    "出口压力": "出口壓力",
    "电流": "電流",
    "电压": "電壓",
    "扭矩": "扭矩",
    "未绑定": "未綁定",
    "请选择设备": "請選擇設備",
    "请选择类型": "請選擇類型",
    "采集卡编码": "采集卡編碼",
    "采集卡ip": "采集卡ip",
    "采集卡类型": "采集卡類型",
    "工厂名称": "工廠名稱",
    "传感器通道": "傳感器通道",
    "通道": "通道",
    "采集卡配置": "采集卡配置",
    "基本信息": "基本信息",
    "采集配置": "采集配置",
    "采集间隔": "采集間隔",
    "工况通道配置": "工況通道配置",
    "工况通道号": "工況通道號",
    "选择测点": "選擇測點",
    "请填写采集卡编码": "請填寫采集卡編碼",
    "请选择采集卡类型": "請選擇采集卡類型",
    "请选择区域": "請選擇區域",
    "请填写安装位置": "請填寫安裝位置",
    "请填写采集卡ip": "請填寫采集卡ip",
    "请完成工况通道配置的编辑后提交": "請完成工況通道配置的編輯後提交",
    "请选择采集卡类型后操作": "請選擇采集卡類型後操作！",
    "采集卡id": "采集卡id",
    "ip地址": "ip地址",
    "边缘电脑绑定": "邊緣電腦綁定",
    "波形采集配置": "波形采集配置",
    "采集方式": "采集方式",
    "波形间隔": "波形間隔",
    "采样频率": "采樣頻率",
    "采样时长": "采樣時長",
    "监测指标采集配置": "監測指標采集配置",
    "均方根间隔": "均方根間隔",
    "触发条件需要同时满足不填写触发条件系统即认为触发条件满足等同于定时采集": "觸發條件需要同時滿足。不填寫觸發條件，系統即認為觸發條件滿足，等同於定時采集",
    "通道配置": "通道配置",
    "通道号": "通道號",
    "关联测点名称": "關聯測點名稱",
    "灵敏度": "靈敏度",
    "轴向": "軸向",
    "轴向名称": "軸向名稱",
    "定时采集": "定時采集",
    "满足触发条件的定时采集": "滿足觸發條件的定時采集",
    "所选通道数量小于通道配置数量": "所選通道數量小於通道配置數量",
    "请选择采集卡类型后再添加": "請選擇采集卡類型後再添加",
    "通道数量超过所选的": "通道數量超過所選的",
    "请填写ip地址": "請填寫ip地址",
    "请选择波形采集配置的波形间隔": "請選擇波形采集配置的波形間隔",
    "请选择波形采集配置的采样频率": "請選擇波形采集配置的采樣頻率",
    "请选择波形采集配置的采样时长": "請選擇波形采集配置的采樣時長",
    "请选择检测指标采集配置的波形间隔": "請選擇檢測指標采集配置的波形間隔",
    "请选择检测指标采集配置的采样频率": "請選擇檢測指標采集配置的采樣頻率",
    "请完成通道配置的编辑后提交": "請完成通道配置的編輯後提交",
    "通道号过大": "通道號大於",
    "请填写灵敏度后提交": "請填寫靈敏度後提交",
    "切片数": "切片數",
    "滤波方式": "濾波方式",
    "滤波频段": "濾波頻段",
    "请选择滤波方式": "請選擇濾波方式",
    "新增行": "新增行",
    "选择设备": "選擇設備",
    "带通滤波": "帶通濾波",
    "带阻滤波": "帶阻濾波",
    "设备选择": "設備選擇",
    "操作日期范围": "操作日期範圍",
    "重置": "重置",
    "项目": "項目",
    "状态清空时间": "狀態清空時間",
    "负责人": "負責人",
    "上一小时状态": "上壹小時狀態",
    "是否改变状态": "是否改變狀態",
    "设备稳定状态清空": "設備穩定狀態清空",
    "指标": "指標",
    "状态清零记录": "狀態清零記錄",
    "状态回升记录": "狀態回升記錄",
    "该设备在此时间点为关机状态请重新选择": "該設備在此時間點為關機狀態，請重新選擇",
    "选择的时间点暂无稳定状态请重新选择": "選擇的時間點暫無穩定狀態,請重新選擇",
    "请选择测点后再选择指标": "請選擇測點後再選擇指標",
    "请选择日期": "請選擇日期",
    "日期范围": "日期範圍",
    "设备参数配置": "設備參數配置",
    "专业指标": "專業指標",
    "通用指标": "通用指標",
    "其他": "其他",
    "其它": "其它",
    "复制": "復制",
    "粘贴覆盖": "粘貼覆蓋",
    "粘贴追加": "粘貼追加",
    "恢复为该测点对应的阈值标准值": "恢復為該測點對應的閾值標準值",
    "未配置标准则保留配置值": "未配置標準則保留配置值",
    "细分故障": "細分故障",
    "计算方法": "計算方法",
    "全选": "全選",
    "复制成功": "復制成功!",
    "请先选择需要复制的内容": "請先選擇需要復制的內容",
    "粘贴成功": "粘貼成功",
    "复制内容无法粘贴在该指标下": "復制內容無法粘貼在該指標下!",
    "请先复制内容": "請先復制內容!",
    "删除成功": "刪除成功",
    "请先选择需要删除的内容": "請先選擇需要刪除的內容",
    "请保存后再切换": "請保存後再切換!",
    "确认执行该操作": "確認執行該操作!",
    "返回": "返回",
    "部件参数": "部件參數",
    "通用参数": "通用參數",
    "部件参数新增": "部件參數新增",
    "部件类型": "部件類型",
    "配置参数": "配置參數",
    "数量": "數量",
    "参数释义": "參數釋義",
    "客户": "客戶",
    "诊断经理": "診斷經理",
    "是否采纳": "是否采納",
    "反馈是否有故障": "反饋是否有故障",
    "是否曾发送诊断事件": "是否曾發送診斷事件",
    "是否更改稳定状态": "是否更改穩定狀態",
    "诊断处理": "診斷處理",
    "发生时间": "發生時間",
    "客户经理": "客戶經理",
    "稳定状态": "穩定狀態",
    "上一小时稳定状态": "上壹小時穩定狀態",
    "事件状态": "事件狀態",
    "是否前台显示": "是否前臺顯示",
    "故障模式一致性": "故障模式壹致性",
    "诊断确认": "診斷確認",
    "调整阈值": "調整閾值",
    "专家报告": "專家報告",
    "状态清零": "狀態清零",
    "诊断事件": "診斷事件",
    "待完成": "待完成",
    "已完成": "已完成",
    "客户反馈": "客戶反饋",
    "确认提交": "確認提交",
    "导出详情": "導出詳情",
    "我的未完成项": "我的未完成項",
    "取消选择": "取消選擇",
    "内部事件类型": "內部事件類型",
    "警戒及以下": "警戒及以下",
    "诊断待处理": "診斷待處理",
    "客户支持待处理": "客戶支持待處理",
    "完成": "完成",
    "诊断判断内部备注": "診斷判斷內部備註",
    "诊断判断备注": "診斷判斷備註",
    "专家报告id": "專家報告id",
    "添加专家报告": "添加專家報告",
    "请确认是否清空当前设备稳定状态": "請確認是否清空當前設備穩定狀態",
    "客户支持": "客戶支持",
    "事件进展": "事件進展",
    "反馈一致性": "反饋壹致性",
    "自动诊断": "自動診斷",
    "人工诊断": "人工診斷",
    "客户支持备注": "客戶支持備註",
    "附件": "附件",
    "否无效反馈": "否,無效反饋",
    "否模糊": "否,模糊",
    "状态反馈一致性": "狀態反饋壹致性",
    "认同": "認同",
    "不认同": "不認同",
    "修改后认同": "修改後認同",
    "部分一致": "部分壹致",
    "去处理": "去處理",
    "有测点数据未传回因此本条分数数据仅供参考": "有測點數據未傳回，因此本條分數數據僅供參考",
    "传感器测点": "傳感器測點",
    "健康度": "健康度",
    "子指标名称": "子指標名稱",
    "子指标值": "子指標值",
    "添加现场检查或维修记录": "添加現場檢查或維修記錄",
    "查看全部": "查看全部",
    "维修记录": "維修記錄",
    "检查记录": "檢查記錄",
    "检修时间": "檢修時間",
    "诊断提醒": "診斷提醒",
    "现场维修": "現場維修",
    "现场检查": "現場檢查",
    "健康诊断分数趋势图": "健康指標診斷分數趨勢圖",
    "振动指标诊断健康分数": "振動指標診斷分數趨勢圖",
    "指标趋势图": "指標趨勢圖",
    "未开机": "未開機",
    "智能诊断": "智能診斷",
    "门限报警": "門限報警",
    "指标监测": "指標監測",
    "智能诊断分数趋势": "智能診斷分數趨勢",
    "指标值对比分析": "指標值對比分析",
    "时域波形图": "時域波形圖",
    "倒频谱图": "倒頻譜圖",
    "交叉相位图": "交叉相位圖",
    "轴心轨迹图": "軸心軌跡圖",
    "瀑布图": "瀑布圖",
    "高频加速度": "高頻加速度",
    "幅值": "幅值",
    "倒频率": "倒頻率",
    "加载中": "加載中...",
    "智能诊断-指标值及分数导出": "智能診斷-指標值及分數導出",
    "实时监测-指标值导出": "實時監測-指標值導出",
    "事件消息-事件清单导出": "事件消息-事件清單導出",
    "app采集数据- 采集记录导出": "app采集數據- 采集記錄導出",
    "原始波形文件下载": "原始波形文件下載",
    "请选择测点": "請選擇測點",
    "请选择时间范围": "請選擇時間範圍",
    "请选择数据类型": "請選擇數據類型",
    "开": "開",
    "关": "關",
    "全设备测点": "全設備測點",
    "设备维修": "設備維修",
    "设备检查": "設備檢查",
    "更换部件": "更換部件",
    "维护": "維護",
    "返厂": "返廠",
    "登录": "登錄",
    "请输入密码": "請輸入密碼",
    "角色名称": "角色名稱",
    "[安全退出]": "[安全退出]",
    "工单查看": "工單查看",
    "小时": "小時",
    "小时s": "小時",
    "请输入操作记录": "請輸入操作記錄",
    "用户添加": "用戶添加",
    "暂无数据": "暫無數據",
    "变频设备常用转频": "變頻設備常用轉頻",
    "是否需要在该测点数据本身找转频": "是否需要在該測點數據本身找轉頻",
    "额定转频": "額定轉頻",
    "是否需要细化频谱": "是否需要細化頻譜",
    "额定电源频率": "額定電源頻率",
    "理论转频所在频谱": "理論轉頻所在頻譜",
    "转频换算系数": "轉頻換算系數",
    "转频或部件频率上限": "轉頻或部件頻率上限",
    "转频或部件频率下限": "轉頻或部件頻率下限",
    "包络谱找转频滤波频段下限": "包絡譜找轉頻濾波頻段下限",
    "转频数据类型": "轉頻數據類型",
    "转频比值": "轉頻比值",
    "叶轮": "葉輪",
    "叶轮级数": "葉輪級數",
    "叶片数目": "葉片數目",
    "轴承": "軸承",
    "保持架特征系数": "保持架特征系數",
    "滚动体特征系数": "滾動體特征系數",
    "外圈特征系数": "外圈特征系數",
    "内圈特征系数": "內圈特征系數",
    "轴承型号": "軸承型號",
    "齿轮箱": "齒輪箱",
    "不超过1个": "不超過1個",
    "齿轮箱种是否含有蜗轮蜗杆": "齒輪箱種是否含有蝸輪蝸桿",
    "齿数": "齒數",
    "蜗杆的头数和蜗轮的齿数": "蝸桿的頭數和蝸輪的齒數",
    "柱塞泵": "柱塞泵",
    "不与其他共同选择": "不與其他共同選擇",
    "柱塞数目": "柱塞數目",
    "柱塞泵滤波参数": "柱塞泵濾波參數",
    "柱塞泵转频上限": "柱塞泵轉頻上限",
    "柱塞泵转频下限": "柱塞泵轉頻下限",
    "行星齿轮箱": "行星齒輪箱",
    "太阳轮齿数": "太陽輪齒數",
    "一倍啮合频率": "壹倍嚙合頻率",
    "行星轮个数": "行星輪個數",
    "齿轮箱(新的指标提取方式)": "齒輪箱（新的指標提取方式）",
    "齿轮齿数": "行星輪個數",
    "螺杆齿数": "行星輪個數",
    "刀头磨损": "刀頭磨損",
    "叶片积灰": "葉片積灰",
    "异常冲击": "異常沖擊",
    "异常特征": "異常特征",
    "叶轮异常": "葉輪異常",
    "冲击烈度": "沖擊烈度",
    "机械松动": "機械松動",
    "滑动轴承松动": "滑動軸承松動",
    "基础松动": "基礎松動",
    "配合松动": "配合松動",
    "机械碰摩": "機械碰摩",
    "缺水干磨": "缺水幹磨",
    "配合不良": "配合不良",
    "零件磨损": "零件磨損",
    "非平稳故障": "非平穩故障",
    "气路共振": "氣路共振",
    "滚动轴承润滑不良": "滾動軸承潤滑不良",
    "滑动轴承油膜涡动": "滑動軸承油膜渦動",
    "滑动轴承油膜振荡": "滑動軸承油膜振蕩",
    "滑动轴承烧瓦": "滑動軸承燒瓦",
    "滑动轴承磨损": "滑動軸承磨損",
    "滚动轴承异常": "滾動軸承異常",
    "电磁振动": "電磁振動",
    "螺杆啮合不良": "螺桿嚙合不良",
    "行星齿轮啮合不良": "行星齒輪嚙合不良",
    "转子不对中": "轉子不對中",
    "转子不平衡": "轉子不平衡",
    "连杆异常": "連桿異常",
    "部件碰摩": "部件碰摩",
    "滑阀碰摩": "滑閥碰摩",
    "滑块碰摩": "滑塊碰摩",
    "滑动轴承碰摩": "滑動軸承碰摩",
    "陶瓷片脱落": "陶瓷片脫落",
    "齿轮啮合不良": "齒輪嚙合不良",
    "明显发展": "明顯發展",
    "发展": "發展",
    "轻微发展": "輕微發展",
    "异常特征减弱": "異常特征減弱",
    "有变化": "有變化",
    "无明显变化": "無明顯變化",
    "恢复健康": "恢復健康",
    "短暂开机": "短暫開機",
    "传输异常": "傳輸異常",
    "振动强度S1": "振動強度S1",
    "振动冲击S2": "振動沖擊S2",
    "振动平衡S3": "振動平衡S3",
    "振动极端S4": "振動極端S4",
    "振动集中S5": "振動集中S5",
    "振动强度S6": "振動強度S6",
    "振动强度S7": "振動強度S7",
    "振动强度S8": "振動強度S8",
    "振动冲击S9": "振動沖擊S9",
    "振动冲击S10": "振動沖擊S10",
    "振动集中S11": "振動集中S11",
    "振动冲击S12": "振動沖擊S12",
    "振动强度S13": "振動強度S13",
    "振动冲击S14": "振動沖擊S14",
    "振动冲击S15": "振動沖擊S15",
    "振动冲击S16": "振動沖擊S16",
    "振动冲击S17": "振動沖擊S17",
    "振动平衡S18": "振動平衡S18",
    "振动冲击S19": "振動沖擊S19",
    "振动强度S20": "振動強度S20",
    "振动强度S21": "振動強度S21",
    "振动强度S22": "振動強度S22",
    "振动强度S23": "振動強度S23",
    "振动强度S24": "振動強度S24",
    "振动强度S26": "振動強度S26",
    "振动强度S27": "振動強度S27",
    "电流指标S25": "電流指標S25",
    "平稳冲击烈度S28": "平穩沖擊烈度S28",
    "速度均方根S29": "速度均方根S29",
    "优化均方根S30": "優化均方根S30",
    "优化峰值S31": "優化峰值S31",
    "优化峰值": "優化峰值",
    "平稳冲击烈度S32": "平穩沖擊烈度S32",
    "优化峭度S33": "優化峭度S33",
    "振动强度S34": "振動強度S34",
    "振动强度S35": "振動強度S35",
    "振动强度S36": "振動強度S36",
    "总设备数": "總設備數",
    "设备数": "設備數",
    "速度": "速度",
    "高频均方根": "高頻均方根",
    "智能设备大屏": "智能設備大屏",
    "设备诊断": "設備診斷",
    "系统管理": "系統管理",
    "诊断趋势": "診斷趨勢",
    "标准监测": "標準監測",
    "图谱分析": "圖譜分析",
    "分析工具": "分析工具",
    "设备事件": "設備事件",
    "设备档案": "設備檔案",
    "数据下载": "數據下載",
    "泵输入端": "泵輸入端",
    "滚动轴承润滑特征": "滾動軸承潤滑特征",
    "信号规律性特征": "信號規律性特征",
    "10～25.6KHz均方根": "10～25.6KHz均方根",
    "优化峭度": "優化峭度",
    "1～10KHz均方根": "1～10KHz均方根",
    "速度均方根": "速度均方根",
    "滚动轴承内圈与外圈": "滾動軸承內圈與外圈",
    "泵输入端存在异常特征，判定为滚动轴承异常，故障部位为轴承内圈和外圈，与2022/1/12事件相比，程度进一步发展；请密切关注设备状态与分数变化情况，并结合现场情况适时安排检查。": "泵輸入端存在異常特征，判定為滾動軸承異常，故障部位為軸承內圈和外圈，與2022/1/12事件相比，程度進壹步發展；請密切關註設備狀態與分數變化情況，並結合現場情況適時安排檢查。",
    "泵端面": "泵端面",
    "非平稳故障01": "非平穩故障01",
    "非平稳故障02": "非平穩故障02",
    "机械碰摩01": "機械碰摩01",
    "机械碰摩02": "機械碰摩02",
    "缺水干磨01": "缺水幹磨01",
    "缺水干磨02": "缺水幹磨02",
    "配合不良01": "配合不良01",
    "配合不良02": "配合不良02",
    "零件磨损01": "零件磨損01",
    "零件磨损02": "零件磨損02",
    "峰峰值": "峰峰值",
    "频谱集中度": "頻譜集中度",
    "0～0.3KHZ均方根": "0～0.3KHZ均方根",
    "全频段均方根": "全頻段均方根",
    "0～1KHZ均方根": "0～1KHZ均方根",
    "偏度因子": "偏度因子",
    "缺水干磨主特征": "缺水幹磨主特征",
    "振动冲击指标12": "振動沖擊指標12",
    "振动冲击指标19": "振動沖擊指標19",
    "振动集中指标11": "振動集中指標11",
    "平稳冲击烈度": "平穩沖擊烈度",
    "碰摩总体特征": "碰摩總體特征",
    "碰摩次阶特征": "碰摩次階特征",
    "碰摩谐波特征": "碰摩諧波特征",
    "碰摩主特征2": "碰摩主特征2",
    "叶片低阶特征": "葉片低階特征",
    "叶片中阶特征": "葉片中階特征",
    "不对中低阶特征": "不對中低階特征",
    "不对中中阶特征": "不對中中階特征",
    "不对中轴向特征": "不對中軸向特征",
    "泵输入端：滚动轴承异常；": "泵輸入端：滾動軸承異常；",
    "泵输入端：部件碰摩、转子不对中；": "泵輸入端：部件碰摩、轉子不對中；",
    "泵输入端：滚动轴承异常、转子不对中与部件碰磨": "泵輸入端：滾動軸承異常、轉子不對中與部件碰磨",
    "滚动轴承内圈和外圈": "滾動軸承內圈和外圈",
    "泵端面：部件碰摩；": "泵端面：部件碰摩；",
    "非平稳故障01，非平稳故障02，振动冲击S19。": "非平穩故障01，非平穩故障02，振動沖擊S19。",
    "非平稳故障02。": "非平穩故障02。",
    "2号反渗透1号增压泵": "2號反滲透1號增壓泵",
    "A线3号超滤循环泵": "A線3號超濾循環泵",
    "滚动轴承损伤": "滾動軸承損傷",
    "非平稳故障01。": "非平穩故障01。",
    "机械碰磨02。": "機械碰磨02。",
    "电源谐波特征": "電源諧波特征",
    "不平衡主特征": "不平衡主特征",
    "优化峭度指标": "優化峭度指標",
    "平稳冲击烈度指标": "\t平穩沖擊烈度指標",
    "振动速度均方根指标": "振動速度均方根指標",
    "外圈特征": "外圈特征",
    "内圈特征": "內圈特征",
    "滚动体特征": "滾動體特征",
    "保持架特征": "保持架特征",
    "振动加速度峰值指标": "振動加速度峰值指標",
    "报告总览": "報告總覽",
    "报告时间": "報告時間",
    "事件是否处理": "事件是否處理",
    "变化趋势": "變化趨勢",
    "Low-frequency acceleration X (m/s2)": "低頻加速度X",
    "Low-frequency acceleration Y (m/s2)": "低頻加速度Y",
    "Low-frequency acceleration Z (m/s2)": "低頻加速度Z",
    "Temperature (°C)": "溫度",
    "Velocity X (mm/s)": "速度X",
    "Velocity Z (mm/s)": "速度Z",
    "Velocity Y (mm/s)": "速度Y",
    "High frequency acceleration (m/s2)": "高頻加速度",
    "传感器电量": "傳感器電量",
    "设备位号": "設備位號",
    "请输入设备位号": "請輸入設備位號",
    "设备功率": "設備功率",
    "请输入设备功率": "請輸入設備功率",
    "设备ID": "設備ID",
    "请输入设备ID": "請輸入設備ID",
    "设备执行人": "設備執行人",
    "请输入设备执行人": "請輸入設備執行人",
    "检测类别": "檢測類別",
    "在线监测": "在線監測",
    "巡检": "巡檢",
    "报告编号": "報告編號",
    "查看报告": "查看報告",
    "设备绑定": "設備綁定",
    "报警内容": "報警內容",
    "发现异常特征，按照巡查计划现场查看设备状态": "發現異常特征，按照巡查計劃現場查看設備狀態",
    "发现明显异常特征，现场检查设备状态，根据现场检查结果更新维护计划，适时维护设备": "發現明顯異常特征，現場檢查設備狀態，根據現場檢查結果更新維護計劃，適時維護設備",
    "设备故障严重，建议停机维修": "設備故障嚴重，建議停機維修",
    "1K～10KHz均方根": "1K～10KHz均方根",
    "10K～25.6KHz均方根": "10K～25.6KHz均方根",
    "分数": "分數",
    "位移峰峰值": "位移峰峰值",
    "巡检阈值管理": "巡檢閾值管理",
    "测点名称": "測點名稱",
    "FX轴承因子": "FX軸承因子",
    "FX冲击因子": "FX沖擊因子",
    "执行人": "執行人",
    "啮合冲击": "嚙合沖擊",
    "星轮磨损": "星輪磨損",
    "滑动轴承润滑不良": "滑動軸承潤滑不良",
    "碰磨": "碰磨",
    "磨盘磨损": "磨盤磨損",
    "螺杆啮合不良01": "螺桿嚙合不良01",
    "螺杆啮合不良03": "螺桿嚙合不良03",
    "螺杆啮合不良02": "螺桿嚙合不良02",
    "连杆异常02": "連桿異常02",
    "连杆异常1": "連桿異常1",
    "螺杆碰摩": "螺桿碰摩",
    "巡检序号": "巡檢序號",
    "全部报告": "全部報告",
    "报警报告": "報警報告",
    "健康报告": "健康報告",
    "巡检设备细分": "巡檢設備細分",
    "智能诊断巡检配置": "智能診斷巡檢配置",
    "请选择设备细分": "請選擇設備細分",
    "处理状态": "處理狀態",
    "状态突破笔数": "狀態突破筆數",
    "是否已放出": "是否已放出",
    "笔": "筆",
    "不限": "不限",
    "设备门限报警配置": "設備門限報警配置",
    "推送配置": "推送配置",
    "基础配置": "基礎配置",
    "OPC变量配置": "OPC變量配置",
    "测点一致性比较": "測點壹致性比較",
    "测点数据统计": "測點數據統計",
    "企业微信模拟推送": "OPC變量配置",
    "监测管理": "監測管理",
    "键": "鍵",
    "分类": "分類"
  }
  
};
